<!-- breadcrumb -->
<input
  #mobileCameraInput
  type="file"
  accept="image/*"
  capture="environment"
  class="d-none"
  (change)="handleMobileCameraCapture($event)"
  />
<ng-template #mobileUploadButton let-orderId="orderId" let-hasFile="hasFile">
  <button
    type="button"
    class="btn btn-sm w-100 text-uppercase mobile-upload-btn"
    [ngClass]="hasFile ? 'btn-success' : 'btn-primary'"
    (click)="triggerMobileUpload(orderId)"
    >
    <i class="fa fa-camera me-1"></i>
    {{ hasFile ? 'Subir nuevamente' : 'Subir orden física' }}
  </button>
</ng-template>
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Ordenes</h4><span
    class="text-muted mt-1 tx-13 ms-2 mb-0">/ Inicio</span>
  </div>
</div>
<div class="d-flex my-xl-auto right-content mr-2">
  <div class="mb-6 mb-xl-0 me-2">
    <div ngbDropdown container="body" class="btn-group">

      <div ngbDropdown container="body" class="d-inline-block wd-xl-100p">
        <button
          type="button"
          class="btn btn-info btn-block"
          id="dropdownBasic1"
          ngbDropdownToggle
          >
          Filtro por Año ({{anioSeleccionado}})
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          @for (number of aniosFiltro; track number) {
            <button ngbDropdownItem  (click)="filtrarOrdenesPorAnio(number)">{{number}}</button>
          }
        </div>
      </div>

    </div>
  </div>
  @if (!isMobileView && canVerMenuNuevaTransaccion) {
    <div class="mb-6 mb-xl-0">
      <div ngbDropdown container="body" class="btn-group">
        <div ngbDropdown container="body" class="d-inline-block wd-xl-100p">
          <button
            type="button"
            class="btn btn-primary btn-block"
            id="dropdownBasic1"
            ngbDropdownToggle
          >
            Nueva transacción
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            @if (canCrearOrdenElectronicaFactura) {
              <button ngbDropdownItem (click)="rutaCrearOrden()">Orden electrónica con Factura</button>
            }
            @if (canCrearOrdenElectronicaConvenio) {
              <button ngbDropdownItem (click)="rutaCrearOrdenSF()">Orden electrónica (Convenio)</button>
            }
            @if (canCrearOrdenFisicaFactura) {
              <button ngbDropdownItem (click)="modalSecuenciaFisica(mdlIngresarSecuencia)">Orden Física Con Factura</button>
            }
            @if (canCrearOrdenFisicaSinFactura) {
              <button ngbDropdownItem (click)="modalSecuenciaFisica(mdlIngresarSecuenciaSF)">Orden Física Sin Factura</button>
            }
            @if (canCrearOrdenElectronicaCitaPrevia) {
              <button ngbDropdownItem (click)="rutaCrearOrdenCitaPrevia()">Orden Electrónica (Cita Previa)</button>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
</div>


<!-- row opened -->
<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">
      <div class="card-header pb-0">
        <!--<div>
        <h6 class="main-content-label mb-1">Filtrar ordenes</h6><br>
        <p><b>SELECCIONE UN ATRIBUTO POR EL QUE DESEA CONSULTAR</b></p>

        <ng-select class="form-control"  [(ngModel)]="atributoBusqueda">
          <ng-option value="">Seleccione...</ng-option>
          <ng-option value="numeroFacturaOrden" >NÚMERO FACTURA</ng-option>
          <ng-option value="NUM_ORD">NÚMERO ORDEN</ng-option>
          <ng-option value="NOM_CLI" selected>NOMBRE PACIENTE</ng-option>
          <ng-option value="CEL_CLI">CELULAR CLIENTE</ng-option>
          <ng-option value="CODN_DOC">CÓDIGO DOCTOR</ng-option>
          <ng-option value="NOM_DOC">NOMBRE DOCTOR</ng-option>
          <ng-option value="DIR_SURC">DIRECCION SUCURSAL</ng-option>
        </ng-select>
        <br>
          <p><b>INGRESE CRITERIO DE BUSQUEDA</b></p>

          <input type="text" class="form-control"  [(ngModel)]="buscarOrden"
            >
        </div>-->
      </div>
      <div class="card-body">
        @if (spinnerBoolean) {
          <div class="text-center">
            <div class="spinner-grow" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br>
              <p class="text-center">Procesando por favor espere...</p>
            </div>
          }
          <div class="text-wrap ">
            <div class="example">
              <div class="panel panel-primary tabs-style-3">
                <div class="tab-menu-heading">
                  <div class="tabs-menu">
                    <!-- Tabs -->
                    <ul ngbNav #nav3="ngbNav" class="nav panel-tabs"  orientation="horizantal" [activeId]="activeTab">
                      @if (!isMobileView && canVerTabPendientes) {
                        <li ngbNavItem="1" >
                          <a ngbNavLink class="" (click)="cambiarEstado('pendiente', 'normal')"><i class="fa fa-cube"></i>&nbsp; Pendientes</a>
                          <ng-template ngbNavContent>
                            <div class="table-responsive">
                              <table  datatable [dtOptions]="dtOptionsSN" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Factura</th>
                                    <th>Nº Orden</th>
                                    <th>Paciente</th>
                                    <th>Celular Paciente</th>
                                    <th>Fec. Nacimiento Paciente</th>
                                    <th>Cod. Doctor</th>
                                    <th>Doctor</th>
                                    <th>Sucursal</th>
                                    <th>Fecha de registro</th>
                                    <th>Tipo</th>
                                    <th>Responsable</th>
                                    <th>Acciones</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (dt of ordenes; track dt.COD_ORD; let rowIndex = $index) {
                                    <tr   >
                                      <td>{{dt.id}}</td>
                                      <td> - </td>
                                      <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                                      @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !='') {
                                        <div>
                                          <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                                        </div>
                                      }
                                    </td>
                                    <td>{{ dt.nombre }}</td>
                                    <td>{{ dt.telefono }} </td>
                                    <td>@if (ordenes[rowIndex].FEC_CLI !== null) {
                                      <div>
                                        <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                                      </div>
                                    }
                                    @if (ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null') {
                                      <div>
                                        <div class="text-center text-danger">NO ESTABLECIDO</div>
                                      </div>
                                    }</td>
                                    <td>{{ dt.codigoDoctor }}</td>
                                    <td>{{ dt.nombreDoctor }}</td>
                                    <td>{{ dt.direccionSucursal }}</td>
                                    <td>{{ dt.fechaVisita }}</td>
                                    <td>@if (ordenes[rowIndex].tipo === 'WEB') {
                                      <div>
                                        <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                                      </div>
                                    }
                                    @if (ordenes[rowIndex].tipo === 'MOVIL') {
                                      <div>
                                        <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                                      </div>
                                    }
                                  </td>
                                  <td> - </td>
                                  <td>
                                    @if (isMobileView) {
                                      <ng-container *ngTemplateOutlet="mobileUploadButton; context: { orderId: ordenes[rowIndex].COD_ORD, hasFile: !!ordenes[rowIndex].ordenFisica }"></ng-container>
                                      @if (ordenes[rowIndex].ordenFisica) {
                                        <button
                                          type="button"
                                          class="btn btn-outline-secondary btn-sm w-100 mt-2 mobile-view-btn"
                                          (click)="viewExistingMobilePreview(ordenes[rowIndex].ordenFisica)"
                                          >
                                          <i class="fa fa-eye me-1"></i> Ver foto subida
                                        </button>
                                      }
                                    }
                                    @if (!isMobileView) {
                                      <div ngbDropdown container="body">
                                        <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                          <i class="fe fe-settings"></i>
                                        </button>
                                        <div class="tx-13" ngbDropdownMenu>
                                          @if (canVerAuditoriaSubidas) {
                                            <a ngbDropdownItem href="javascript:;" (click)="abrirAuditoriaOrden(mdlAuditoriaSubidas, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NUM_ORD)">
                                              <i class="fa fa-history text-info" aria-hidden="true"></i> <b>&nbsp;&nbsp;AUDITORÍA IMÁGENES</b>
                                            </a>
                                          }
                                          @if (ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null' ||  ordenes[rowIndex].secuenciaOrden =='') {
                                            <div>
                                              <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                                                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
                                              </a>
                                            </div>
                                          }
                                          <a ngbDropdownItem href="javascript:;" (click)="enviarAccesosWSPaciente(ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].CED_CLI, ordenes[rowIndex].TEL_CLI)">
                                            <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ACCESOS A PACIENTE</b>
                                          </a>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="editarOrden(ordenes[rowIndex].COD_ORD)">
                                              <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;EDITAR</b>
                                            </a>
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;"  (click)="facturarOrden(ordenes[rowIndex].COD_ORD)">
                                              <i class="fab fa-wpforms text-info" aria-hidden="true"  ></i> <b>&nbsp;&nbsp;FACTURAR</b>
                                            </a>
                                          </div>
                                          <div>
                                            @if (ordenes[rowIndex].NOTPAC_ORD ==null ||  ordenes[rowIndex].NOTPAC_ORD =='null' || ordenes[rowIndex].NOTPAC_ORD =='') {
                                              <div>
                                                <a ngbDropdownItem href="javascript:;"  (click)="notificarPendientePac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;NOTIFICAR PACIENTE (0)</b>
                                                </a>
                                              </div>
                                            }
                                            @if (ordenes[rowIndex].NOTPAC_ORD !=null  &&  ordenes[rowIndex].NOTPAC_ORD !='null' && ordenes[rowIndex].NOTPAC_ORD !='') {
                                              <div>
                                                <a ngbDropdownItem href="javascript:;"  (click)="notificarPendientePac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;NOTIFICAR PACIENTE ({{ordenes[rowIndex].NOTPAC_ORD}})</b>
                                                </a>
                                              </div>
                                            }
                                          </div>
                                          <div>
                                            @if (ordenes[rowIndex].NOTPACORD_ORD ==null ||  ordenes[rowIndex].NOTPACORD_ORD =='null' || ordenes[rowIndex].NOTPACORD_ORD =='') {
                                              <div>
                                                <a ngbDropdownItem href="javascript:;"  (click)="enviarOrdenPac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ORDEN PACIENTE (0)</b>
                                                </a>
                                              </div>
                                            }
                                            @if (ordenes[rowIndex].NOTPACORD_ORD !=null  &&  ordenes[rowIndex].NOTPACORD_ORD !='null' && ordenes[rowIndex].NOTPACORD_ORD !='') {
                                              <div>
                                                <a ngbDropdownItem href="javascript:;"  (click)="enviarOrdenPac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ORDEN PACIENTE ({{ordenes[rowIndex].NOTPACORD_ORD}})</b>
                                                </a>
                                              </div>
                                            }
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                                              <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
                                            </a>
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;"  (click)="eliminarOrden(ordenes[rowIndex].COD_ORD)">
                                              <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR</b>
                                            </a>
                                          </div>
                                          @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null') {
                                            <div>
                                              <a ngbDropdownItem href="javascript:;"  (click)="eliminarSecuenciaFisica(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].secuenciaOrden )">
                                                <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR SECUENCIA FISICA</b>
                                              </a>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    }
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          <!--<ngx-datatable #table class='bootstrap' [rows]="ordenes"  columnMode="force"  [headerHeight]="50" [footerHeight]="50"
                          rowHeight="auto" [summaryRow]="true" [summaryPosition]="'bottom'"  [externalPaging]="true" [limit]="size" [count]="totalElements"
                          [offset]="pageNumber" (page)="setPage($event)"
                          >
                          <ngx-datatable-column name="N. Orden" prop='NUM_ORD'>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                              <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">
                                <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                              </div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Paciente" prop="NOM_CLI"  >
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].NOM_CLI}}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Tel. Paciente" prop='TEL_CLI'>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center"><i class="zmdi zmdi-whatsapp text-success"></i> {{ordenes[rowIndex].TEL_CLI}}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Fec. Nac. Paciente" prop='FEC_CLI'>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div *ngIf="ordenes[rowIndex].FEC_CLI !== null">
                                <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                              </div>
                              <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">
                                <div class="text-center text-danger">NO ESTABLECIDO</div>
                              </div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Cod. Doctor" prop='CODN_DOC'>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].CODN_DOC}}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Doctor" prop='NOM_DOC'>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Fecha registro" prop="fecha">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Tipo" prop="tipo">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">
                                <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                              </div>
                              <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">
                                <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                              </div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Acciones" prop="Acciones">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row" >
                              <div ngbDropdown container="body">
                                <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                  <i class="fe fe-settings"></i>
                                </button>
                                <div class="tx-13" ngbDropdownMenu>
                                  <div *ngIf="ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null'">
                                    <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                                      <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
                                    </a>
                                  </div>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="editarOrden(ordenes[rowIndex].COD_ORD)">
                                      <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;EDITAR</b>
                                    </a>
                                  </div>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;"  (click)="facturarOrden(ordenes[rowIndex].COD_ORD)">
                                      <i class="fab fa-wpforms text-info" aria-hidden="true"  ></i> <b>&nbsp;&nbsp;FACTURAR</b>
                                    </a>
                                  </div>
                                  <div>
                                    <div *ngIf="ordenes[rowIndex].NOTPAC_ORD ==null ||  ordenes[rowIndex].NOTPAC_ORD =='null' || ordenes[rowIndex].NOTPAC_ORD ==''">
                                      <a ngbDropdownItem href="javascript:;"  (click)="notificarPendientePac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;NOTIFICAR PACIENTE (0)</b>
                                      </a>
                                    </div>
                                    <div *ngIf="ordenes[rowIndex].NOTPAC_ORD !=null  &&  ordenes[rowIndex].NOTPAC_ORD !='null' && ordenes[rowIndex].NOTPAC_ORD !=''">
                                      <a ngbDropdownItem href="javascript:;"  (click)="notificarPendientePac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;NOTIFICAR PACIENTE ({{ordenes[rowIndex].NOTPAC_ORD}})</b>
                                      </a>
                                    </div>
                                  </div>
                                  <div>
                                    <div *ngIf="ordenes[rowIndex].NOTPACORD_ORD ==null ||  ordenes[rowIndex].NOTPACORD_ORD =='null' || ordenes[rowIndex].NOTPACORD_ORD ==''">
                                      <a ngbDropdownItem href="javascript:;"  (click)="enviarOrdenPac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ORDEN PACIENTE (0)</b>
                                      </a>
                                    </div>
                                    <div *ngIf="ordenes[rowIndex].NOTPACORD_ORD !=null  &&  ordenes[rowIndex].NOTPACORD_ORD !='null' && ordenes[rowIndex].NOTPACORD_ORD !=''">
                                      <a ngbDropdownItem href="javascript:;"  (click)="enviarOrdenPac(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NOM_DOC, ordenes[rowIndex].CEL_DOC, ordenes[rowIndex].NOM_CLI, ordenes[rowIndex].TEL_CLI, ordenes[rowIndex].NUM_ORD)">
                                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ORDEN PACIENTE ({{ordenes[rowIndex].NOTPACORD_ORD}})</b>
                                      </a>
                                    </div>
                                  </div>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                                      <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
                                    </a>
                                  </div>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;"  (click)="eliminarOrden(ordenes[rowIndex].COD_ORD)">
                                      <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR</b>
                                    </a>
                                  </div>
                                  <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">
                                    <a ngbDropdownItem href="javascript:;"  (click)="eliminarSecuenciaFisica(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].secuenciaOrden )">
                                      <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR SECUENCIA FISICA</b>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </ngx-datatable-column>
                          <ngx-datatable-column name="Resp." prop="nombre">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                              let-row="row">
                              <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">
                                <div class="text-center">-</div>
                              </div>
                              <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">
                                {{ordenes[rowIndex].numeroFacturaOrden}}
                              </div>
                            </ng-template>
                          </ngx-datatable-column>
                        </ngx-datatable>-->
                      </div>
                    </ng-template>
                  </li>
                }
              @if (canVerTabPendientesFacturadas) {
                <li ngbNavItem="2">
                  <a ngbNavLink class="" (click)="cambiarEstado('facturadas', 'normal')"><i class="fa fa-cube"></i>&nbsp; Pendientes Facturadas</a>
                  <ng-template ngbNavContent>




                    <table    datatable [dtOptions]="dtOptionsSN" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">

                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Factura</th>
                          <th>Nº Orden</th>
                          <th>Paciente</th>
                          <th>Celular Paciente</th>
                          <th>Fec. Nacimiento Paciente</th>
                          <th>Cod. Doctor</th>
                          <th>Doctor</th>
                          <th>Sucursal</th>
                          <th>Fecha de registro</th>
                          <th>Tipo</th>
                          <th>Responsable</th>
                          <th>Acciones</th>



                        </tr>
                      </thead>
                      <tbody>


                        @for (dt of ordenes; track dt.COD_ORD || dt.NUM_ORD || dt.id; let rowIndex = $index) {
                          <tr   >
                            <td>{{dt.id}}</td>
                            <td>
                              @if (!ordenes[rowIndex].factura && ordenes[rowIndex].convenio == '1') {
                                <div>
                                  <div class="text-center text-success">FACTURA CONVENIO</div>
                                </div>
                              }
                              @if (ordenes[rowIndex].factura) {
                                <div>
                                  <div class="text-center">{{dt.factura}}</div>
                                  </div
                                  >
                                }</td>
                                <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                                @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !='') {
                                  <div>
                                    <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                                  </div>
                                }
                              </td>
                              <td>{{ dt.nombre }}</td>
                              <td>{{ dt.telefono }} </td>
                              <td>@if (ordenes[rowIndex].FEC_CLI !== null) {
                                <div>
                                  <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                                </div>
                              }
                              @if (ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null') {
                                <div>
                                  <div class="text-center text-danger">NO ESTABLECIDO</div>
                                </div>
                              }</td>
                              <td>{{ dt.codigoDoctor }}</td>
                              <td>{{ dt.nombreDoctor }}</td>
                              <td>{{ dt.direccionSucursal }}
                                @if (dt.SUCVIST_ORD) {
                                  <div class="text-success">Cita: {{ dt.SUCVIST_ORD }}</div>
                                }
                              </td>
                              <td>{{ dt.fechaVisita }}</td>
                              <td>@if (ordenes[rowIndex].tipo === 'WEB') {
                                <div>
                                  <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                                </div>
                              }
                              @if (ordenes[rowIndex].tipo === 'MOVIL') {
                                <div>
                                  <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                                </div>
                              }
                            </td>
                            <td>{{dt.responsable}}</td>
                            <td>
                              @if (isMobileView) {
                                <ng-container *ngTemplateOutlet="mobileUploadButton; context: { orderId: ordenes[rowIndex].COD_ORD, hasFile: !!ordenes[rowIndex].ordenFisica }"></ng-container>
                                @if (ordenes[rowIndex].ordenFisica) {
                                  <button
                                    type="button"
                                    class="btn btn-outline-secondary btn-sm w-100 mt-2 mobile-view-btn"
                                    (click)="viewExistingMobilePreview(ordenes[rowIndex].ordenFisica)"
                                    >
                                    <i class="fa fa-eye me-1"></i> Ver foto subida
                                  </button>
                                }
                              }
                              @if (!isMobileView) {
                                <div ngbDropdown container="body">
                                  <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                    <i class="fe fe-settings"></i>
                                  </button>
                                  <div class="tx-13" ngbDropdownMenu>
                                    @if (canVerAuditoriaSubidas) {
                                      <a ngbDropdownItem href="javascript:;" (click)="abrirAuditoriaOrden(mdlAuditoriaSubidas, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NUM_ORD)">
                                        <i class="fa fa-history text-info" aria-hidden="true"></i> <b>&nbsp;&nbsp;AUDITORÍA IMÁGENES</b>
                                      </a>
                                    }
                                    <!--<div *ngIf="perfil !== 'Facturador'">
                                    <a ngbDropdownItem href="javascript:;"  (click)="subirImagenes(ordenes[rowIndex].COD_ORD)">
                                      <i class="far fa-file-image text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;AÑADIR IMÁGENES</b>
                                    </a>
                                  </div>-->
                                  <div >
                                    <a ngbDropdownItem href="javascript:;"  (click)="cambiarEstadoOrden(ordenes[rowIndex].COD_ORD)">
                                      <i class="far fa-check text-sucess" aria-hidden="true"></i> <b>&nbsp;&nbsp;MARCAR COMO ATENDIDA</b>
                                    </a>
                                  </div>
                                  @if (ordenes[rowIndex].convenio === '1') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;"  (click)="eliminarOrden(ordenes[rowIndex].COD_ORD)">
                                        <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR</b>
                                      </a>
                                    </div>
                                  }
                                  @if (!ordenes[rowIndex].ordenFisica) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;"  (click)="mostrarModalSubirOrden(ordenes[rowIndex].COD_ORD, mdlSubirOrdenFisica)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;SUBIR ORDEN FISICA</b>
                                      </a>
                                    </div>
                                  }
                                  @if (ordenes[rowIndex].ordenFisica) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;"  (click)="mostrarModalSubirOrden(ordenes[rowIndex].COD_ORD, mdlSubirOrdenFisica)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;SUBIR NUEVAMENTE ORDEN FISICA</b>
                                      </a>
                                    </div>
                                  }
                                  @if (ordenes[rowIndex].ordenFisica) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;"  (click)="verOrdenFisica(ordenes[rowIndex].ordenFisica)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;VER ORDEN FISICA</b>
                                      </a>
                                    </div>
                                  }
                                  <div >
                                    <a ngbDropdownItem href="javascript:;" (click)="enviarAccesosWSPaciente(ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].CED_CLI, ordenes[rowIndex].TEL_CLI)">
                                      <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ACCESOS A PACIENTE</b>
                                    </a>
                                  </div>
                                  <a  ngbDropdownItem href="javascript:;" (click)="imprimirTicket(ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].numeroFacturaOrden)">
                                    <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR TICKET FACTURA</b>
                                  </a>
                                  <a ngbDropdownItem href="javascript:;" (click)="imprimirReciboInterno(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].numeroFacturaOrden)">
                                    <i class="fa fa-table text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;RECIBO INTERNO</b>
                                  </a>
                                  @if (ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null' ||  ordenes[rowIndex].secuenciaOrden =='') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                                        <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
                                      </a>
                                    </div>
                                  }
                                  @if (modifyDoctor.includes(codeUserModify)) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="modificarDoctor(mdlModificarDoctor,ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].secuenciaOrden, ordenes[rowIndex].nombreDoctor)">
                                        <i class="zmdi zmdi-collection-text text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;MODIFICAR DOCTOR</b>
                                      </a>
                                    </div>
                                  }
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                                      <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
                                    </a>
                                  </div>
                                  @if (ordenes[rowIndex].LAB_ORD == 'laboratorio') {
                                    <div>
                                      <a  ngbDropdownItem href="javascript:;" (click)="imprimirTicketLaboratorio(ordenes[rowIndex].NUM_ORD)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR TICKET LABORATORIO</b>
                                      </a>
                                    </div>
                                  }
                                  @if (ordenes[rowIndex].envioSRI=='1') {
                                    <div>
                                      <a  ngbDropdownItem href="javascript:;" (click)="enviarFacturaSRI(ordenes[rowIndex].COD_ORD)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR FACTURA SRI</b>
                                      </a>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>



                  </table>
                  <!--<div class="table-responsive">
                  <ngx-datatable #table class='bootstrap' [rows]="ordenes"  columnMode="force"  [headerHeight]="50" [footerHeight]="50"
                    rowHeight="auto" [summaryRow]="true" [summaryPosition]="'bottom'"  [externalPaging]="true" [limit]="size" [count]="totalElements"
                    [offset]="pageNumber" (page)="setPage($event)"
                    >




                    <ngx-datatable-column name="N. FAC" prop='numeroFacturaOrden'>

                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

                          <div class="text-center">-</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

                          <div class="text-center">{{ordenes[rowIndex].numeroFacturaOrden}}</div>
                        </div>

                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="N. Orden" prop='NUM_ORD'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                        <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">

                          <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Paciente" prop="NOM_CLI"  >
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].NOM_CLI}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Tel. Paciente" prop='TEL_CLI'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center"><i class="zmdi zmdi-whatsapp text-success"></i> {{ordenes[rowIndex].TEL_CLI}}</div>

                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Fec. Nac. Paciente" prop='FEC_CLI'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

                          <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

                          <div class="text-center text-danger">NO ESTABLECIDO</div>
                        </div>


                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Cod. Doctor" prop='CODN_DOC'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].CODN_DOC}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Doctor" prop='NOM_DOC'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Fecha registro" prop="fecha">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Tipo" prop="tipo">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

                          <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

                          <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                        </div>



                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Acciones" prop="Acciones">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row" >



                        <div ngbDropdown container="body">

                          <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">

                            <i class="fe fe-settings"></i>

                          </button>


                          <div class="tx-13" ngbDropdownMenu>

                            <div >
                              <a ngbDropdownItem href="javascript:;"  (click)="subirImagenes(ordenes[rowIndex].COD_ORD)">
                                <i class="far fa-file-image text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;AÑADIR IMÁGENES</b>
                              </a>
                            </div>

                            <div *ngIf="ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null'">
                              <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
                              </a>
                            </div>




                            <div>
                              <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                                <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
                              </a>
                            </div>


                          </div>


                        </div>

                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Resp." prop="nombre">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

                          <div class="text-center">-</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

                          {{ordenes[rowIndex].numeroFacturaOrden}}
                        </div>


                      </ng-template>
                    </ngx-datatable-column>



                  </ngx-datatable>-->

                </ng-template>
                </li>
              }
              @if (canVerTabAtendidas) {
                <li ngbNavItem="3">
                <a ngbNavLink class="" (click)="cambiarEstado('con-imagenes', 'normal')"><i class="fa fa-cube"></i>&nbsp;Atendidas</a>
                <ng-template ngbNavContent>
                  <table    datatable [dtOptions]="dtOptionsSN" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">

                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Factura</th>
                        <th>Nº Orden</th>
                        <th>Paciente</th>
                        <th>Celular Paciente</th>
                        <th>Fec. Nacimiento Paciente</th>
                        <th>Cod. Doctor</th>
                        <th>Doctor</th>
                        <th>Sucursal</th>
                        <th>Fecha de registro</th>
                        <th>Tipo</th>
                        <th>Responsable</th>
                        <th>Acciones</th>



                      </tr>
                    </thead>
                    <tbody>


                      @for (dt of ordenes; track dt.COD_ORD || dt.NUM_ORD || dt.id; let rowIndex = $index) {
                        <tr   >
                          <td>{{dt.id}}</td>
                          <td>
                            @if (!ordenes[rowIndex].factura && ordenes[rowIndex].convenio == '1') {
                              <div>
                                <div class="text-center text-success">FACTURA CONVENIO</div>
                              </div>
                            }
                            @if (ordenes[rowIndex].factura) {
                              <div>
                                <div class="text-center">{{dt.factura}}</div>
                                </div
                                >
                              }</td>
                              <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                              @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !='') {
                                <div>
                                  <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                                </div>
                              }
                            </td>
                            <td>{{ dt.nombre }}
                              @if (ordenes[rowIndex].informeCorporal !=null &&  ordenes[rowIndex].informeCorporal !='null'  &&  ordenes[rowIndex].informeCorporal !='') {
                                <div class="text-center"> <p class="text-success">INFORME RX CORPORAL PROCESADO</p></div>
                              }
                            </td>
                            <td>{{ dt.telefono }} </td>
                            <td>@if (ordenes[rowIndex].FEC_CLI !== null) {
                              <div>
                                <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                              </div>
                            }
                            @if (ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null') {
                              <div>
                                <div class="text-center text-danger">NO ESTABLECIDO</div>
                              </div>
                            }</td>
                            <td>{{ dt.codigoDoctor }}</td>
                            <td>{{ dt.nombreDoctor }}</td>
                            <td>{{ dt.direccionSucursal }}
                              @if (dt.SUCVIST_ORD) {
                                <div class="text-success">Cita: {{ dt.SUCVIST_ORD }}</div>
                              }
                            </td>
                            <td>{{ dt.fechaVisita }}
                              @if (ordenes[rowIndex].FEC_REGIMG !== null) {
                                <div>
                                  <b>Procesado:</b> <p class="text-success">{{ordenes[rowIndex].FEC_REGIMG}}</p>
                                </div>
                              }
                            </td>
                            <td>@if (ordenes[rowIndex].tipo === 'WEB') {
                              <div>
                                <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                              </div>
                            }
                            @if (ordenes[rowIndex].tipo === 'MOVIL') {
                              <div>
                                <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                              </div>
                            }
                          </td>
                          <td>{{dt.responsable}}</td>
                          <td>
                            @if (isMobileView) {
                              <ng-container *ngTemplateOutlet="mobileUploadButton; context: { orderId: ordenes[rowIndex].COD_ORD, hasFile: !!ordenes[rowIndex].ordenFisica }"></ng-container>
                              @if (ordenes[rowIndex].ordenFisica) {
                                <button
                                  type="button"
                                  class="btn btn-outline-secondary btn-sm w-100 mt-2 mobile-view-btn"
                                  (click)="viewExistingMobilePreview(ordenes[rowIndex].ordenFisica)"
                                  >
                                  <i class="fa fa-eye me-1"></i> Ver foto subida
                                </button>
                              }
                            }
                            @if (!isMobileView) {
                              <div ngbDropdown container="body">
                                <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                  <i class="fe fe-settings"></i>
                                </button>
                                <div class="tx-13 order-actions-menu" ngbDropdownMenu>
                                  <h6 class="dropdown-header">GESTIÓN DE LA ORDEN</h6>
                                  @if (canVerAuditoriaSubidas) {
                                    <a ngbDropdownItem href="javascript:;" (click)="abrirAuditoriaOrden(mdlAuditoriaSubidas, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].NUM_ORD)">
                                      <i class="fa fa-history text-info" aria-hidden="true"></i> <b>&nbsp;&nbsp;AUDITORÍA IMÁGENES</b>
                                    </a>
                                  }
                                  @if (ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null'  ||  ordenes[rowIndex].secuenciaOrden =='') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                                        <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
                                      </a>
                                    </div>
                                  }
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="editarOrdenImagenes(ordenes[rowIndex].COD_ORD)">
                                      <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;EDITAR ORDEN</b>
                                    </a>
                                  </div>
                                  @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="eliminarSecuenciaFisica(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].secuenciaOrden )">
                                        <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR SECUENCIA FÍSICA</b>
                                      </a>
                                    </div>
                                  }
                                  @if (modifyDoctor.includes(codeUserModify)) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="modificarDoctor(mdlModificarDoctor,ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].secuenciaOrden, ordenes[rowIndex].nombreDoctor)">
                                        <i class="zmdi zmdi-collection-text text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;MODIFICAR DOCTOR</b>
                                      </a>
                                    </div>
                                  }
                                  @if (!ordenes[rowIndex].ordenFisica) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="mostrarModalSubirOrden(ordenes[rowIndex].COD_ORD, mdlSubirOrdenFisica)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;SUBIR ORDEN FÍSICA</b>
                                      </a>
                                    </div>
                                  }
                                  @if (ordenes[rowIndex].ordenFisica) {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="mostrarModalSubirOrden(ordenes[rowIndex].COD_ORD, mdlSubirOrdenFisica)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;REEMPLAZAR ORDEN FÍSICA</b>
                                      </a>
                                    </div>
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="verOrdenFisica(ordenes[rowIndex].ordenFisica)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;VER ORDEN FÍSICA</b>
                                      </a>
                                    </div>
                                  }
                                  <div class="dropdown-divider"></div>
                                  <h6 class="dropdown-header">COMUNICACIÓN CON EL PACIENTE</h6>
                                  <a ngbDropdownItem href="javascript:;" (click)="enviarAccesosWSPaciente(ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].CED_CLI, ordenes[rowIndex].TEL_CLI)">
                                    <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR ACCESOS A PACIENTE</b>
                                  </a>
                                  <div class="dropdown-divider"></div>
                                  <h6 class="dropdown-header">RESULTADOS</h6>
                                  <a ngbDropdownItem href="javascript:;" (click)="abrirGestionResultados(mdlGestionResultados, ordenes[rowIndex])">
                                    <i class="zmdi zmdi-share text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;GESTIONAR RESULTADOS</b>
                                  </a>
                                  <div class="dropdown-divider"></div>
                                  <h6 class="dropdown-header">DOCUMENTOS E INFORMES</h6>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                                      <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR ORDEN</b>
                                    </a>
                                  </div>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="imprimirTicket(ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].numeroFacturaOrden)">
                                      <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR TICKET FACTURA</b>
                                    </a>
                                  </div>
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="imprimirReciboInterno(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].numeroFacturaOrden)">
                                      <i class="fa fa-table text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;RECIBO INTERNO</b>
                                    </a>
                                  </div>
                                  @if (ordenes[rowIndex].LAB_ORD == 'laboratorio') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="imprimirTicketLaboratorio(ordenes[rowIndex].NUM_ORD)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR TICKET LABORATORIO</b>
                                      </a>
                                    </div>
                                  }
                                  @if (ordenes[rowIndex].LAB_ORD == 'laboratorio' && ordenes[rowIndex].estado_laboratorio == 'con-resultados') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="imprimirResultado(ordenes[rowIndex].COD_ORD, ordenes[rowIndex].FEC_ORD)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;VER RESULTADOS LABORATORIO</b>
                                      </a>
                                    </div>
                                  }
                                  <div>
                                    <a ngbDropdownItem href="javascript:;" (click)="verInformeRxCorporal(ordenes[rowIndex].COD_ORD)">
                                      <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;VER INFORME RX CORPORAL</b>
                                    </a>
                                  </div>
                                  @if (ordenes[rowIndex].generateReports == 1 || ordenes[rowIndex].generateReports == '1') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="verInformesRx(ordenes[rowIndex])">
                                        <i class="zmdi zmdi-assignment text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;VER INFORMES RX</b>
                                      </a>
                                    </div>
                                  }
                                  @if (dt.envioSRI=='1' || (dt.factura!='' && dt.factura!='null' && dt.factura!='null')) {
                                    <div class="dropdown-divider"></div>
                                    <h6 class="dropdown-header">FACTURACIÓN</h6>
                                  }
                                  @if (dt.envioSRI=='1') {
                                    <div>
                                      <a ngbDropdownItem href="javascript:;" (click)="enviarFacturaSRI(ordenes[rowIndex].COD_ORD)">
                                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR FACTURA SRI</b>
                                      </a>
                                    </div>
                                  }
                                  @if (dt.factura!='' && dt.factura!='null' && dt.factura!='null') {
                                    <div>
                                      <a  ngbDropdownItem href="javascript:;" (click)="enviarFacturaCliente(ordenes[rowIndex].COD_ORD)">
                                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR FACTURA POR WHATSAPP</b>
                                      </a>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>



                  </table>
                  <!--<div class="table-responsive">
                  <ngx-datatable #table class='bootstrap' [rows]="ordenes"  columnMode="force"  [headerHeight]="50" [footerHeight]="50"
                    rowHeight="auto" [summaryRow]="true" [summaryPosition]="'bottom'"  [externalPaging]="true" [limit]="size" [count]="totalElements"
                    [offset]="pageNumber"
                    >




                    <ngx-datatable-column name="N. FAC" prop='numeroFacturaOrden'>

                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

                          <div class="text-center">-</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

                          <div class="text-center">{{ordenes[rowIndex].numeroFacturaOrden}}</div>
                        </div>

                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="N. Orden" prop='NUM_ORD'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                        <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">

                          <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Paciente" prop="NOM_CLI"  >
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].NOM_CLI}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Tel. Paciente" prop='TEL_CLI'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center"><i class="zmdi zmdi-whatsapp text-success"></i> {{ordenes[rowIndex].TEL_CLI}}</div>

                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Fec. Nac. Paciente" prop='FEC_CLI'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

                          <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

                          <div class="text-center text-danger">NO ESTABLECIDO</div>
                        </div>


                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Cod. Doctor" prop='CODN_DOC'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].CODN_DOC}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Doctor" prop='NOM_DOC'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Fecha registro" prop="fecha">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Tipo" prop="tipo">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

                          <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

                          <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                        </div>



                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Acciones" prop="Acciones">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row" >



                        <div ngbDropdown container="body">

                          <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">

                            <i class="fe fe-settings"></i>

                          </button>


                          <div class="tx-13" ngbDropdownMenu>

                            <div *ngIf="ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null'">
                              <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
                              </a>
                            </div>


                            <div>
                              <a ngbDropdownItem href="javascript:;" (click)="editarOrdenImagenes(ordenes[rowIndex].COD_ORD)">
                                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;EDITAR</b>
                              </a>
                            </div>

                            <div>
                              <div *ngIf="ordenes[rowIndex].NOTPACIMG_ORD ==null ||  ordenes[rowIndex].NOTPACIMG_ORD =='null' || ordenes[rowIndex].NOTPACIMG_ORD ==''">
                                <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesPaciente(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].TEL_CLI,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A PACIENTE (0)</b>
                                </a>
                              </div>
                              <div *ngIf="ordenes[rowIndex].NOTPACIMG_ORD !=null  &&  ordenes[rowIndex].NOTPACIMG_ORD !='null' && ordenes[rowIndex].NOTPACIMG_ORD !=''">
                                <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesPaciente(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].TEL_CLI,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A PACIENTE ({{ordenes[rowIndex].NOTPACIMG_ORD}})</b>
                                </a>
                              </div>

                            </div>
                            <div>
                              <div *ngIf="ordenes[rowIndex].NOTDOCIMG_ORD ==null ||  ordenes[rowIndex].NOTDOCIMG_ORD =='null' || ordenes[rowIndex].NOTDOCIMG_ORD ==''">
                                <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesDoctor(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].CEL_DOC,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A DOCTOR (0)</b>
                                </a>
                              </div>
                              <div *ngIf="ordenes[rowIndex].NOTDOCIMG_ORD !=null  &&  ordenes[rowIndex].NOTDOCIMG_ORD !='null' && ordenes[rowIndex].NOTDOCIMG_ORD !=''">
                                <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesDoctor(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].CEL_DOC,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


                                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A DOCTOR ({{ordenes[rowIndex].NOTDOCIMG_ORD}})</b>
                                </a>
                              </div>
                            </div>
                            <div>
                              <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                                <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
                              </a>
                            </div>

                            <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">
                              <a ngbDropdownItem href="javascript:;"  (click)="eliminarSecuenciaFisica(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].secuenciaOrden )">
                                <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR SECUENCIA FISICA</b>
                              </a>
                            </div>

                            <div>
                              <a ngbDropdownItem href="javascript:;" (click)="modificarDoctor(mdlModificarDoctor,ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].secuenciaOrden)">
                                <i class="zmdi zmdi-collection-text text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;MODIFICAR DOCTOR</b>
                              </a>
                            </div>

                          </div>


                        </div>

                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Resp." prop="nombre">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                        let-row="row">
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

                          <div class="text-center">-</div>
                        </div>
                        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

                          {{ordenes[rowIndex].numeroFacturaOrden}}
                        </div>


                      </ng-template>
                    </ngx-datatable-column>



                  </ngx-datatable>
                </div>-->
              </ng-template>
                </li>
              }
            <!--<li ngbNavItem="4">
            <a ngbNavLink class="" (click)="dtenvioImagenesPacientes()"><i class="fa fa-cube" ></i>&nbsp;Envio imágenes paciente</a>
            <ng-template ngbNavContent>

              <div class="table-responsive">

                <div *ngIf="ordenes.length<=0">
                  <p>SIN DATOS</p>
                </div>

                <table *ngIf="ordenes.length>0"   datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">

                  <thead>
                    <tr>
                      <th>#</th>

                      <th>Nº Orden</th>
                      <th>Paciente</th>
                      <th>Celular Paciente</th>
                      <th>Fec. Nacimiento Paciente</th>
                      <th>Cod. Doctor</th>
                      <th>Doctor</th>
                      <th>Sucursal</th>
                      <th>Fecha de registro</th>
                      <th>Tipo</th>
                      <th>Fecha de visita</th>

                      <th>Acciones</th>



                    </tr>
                  </thead>
                  <tbody>


                    <tr   *ngFor="let dt of ordenes; let rowIndex = index;" >
                      <td>{{rowIndex+1}}</td>
                      <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                      <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !=''">

                        <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                      </div>
                    </td>

                    <td>{{ dt.NOM_CLI }}</td>
                    <td>{{ dt.TEL_CLI }} </td>
                    <td><div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

                      <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                    </div>
                    <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

                      <div class="text-center text-danger">NO ESTABLECIDO</div>
                    </div></td>
                    <td>{{ dt.CODN_DOC }}</td>
                    <td>{{ dt.NOM_DOC }}</td>
                    <td>{{ dt.DIR_SURC }}</td>
                    <td>{{ dt.fecha }}</td>
                    <td><div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

                      <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                    </div>
                    <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

                      <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                    </div>
                  </td>
                  <td>{{dt.FEC_ORD}}</td>

                  <td>
                    <div class="text-center"><button class="btn btn-success" (click)="envioResultados(ordenes[rowIndex].COD_ORD, 'paciente')"><i class="zmdi zmdi-whatsapp text-white" aria-hidden="true"></i></button></div>
                  </td>

                </tr>
              </tbody>



            </table>
            <!--<ngx-datatable #table class='bootstrap' [rows]="ordenes"  columnMode="force"  [headerHeight]="50" [footerHeight]="50"
            rowHeight="auto" [summaryRow]="true" [summaryPosition]="'bottom'"  [externalPaging]="true" [limit]="size" [count]="totalElements"
            [offset]="pageNumber"
            >




            <ngx-datatable-column name="N. FAC" prop='numeroFacturaOrden'>

              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

                  <div class="text-center">-</div>
                </div>
                <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

                  <div class="text-center">{{ordenes[rowIndex].numeroFacturaOrden}}</div>
                </div>

              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="N. Orden" prop='NUM_ORD'>
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">

                  <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Paciente" prop="NOM_CLI"  >
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].NOM_CLI}}</div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Tel. Paciente" prop='TEL_CLI'>
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center"><i class="zmdi zmdi-whatsapp text-success"></i> {{ordenes[rowIndex].TEL_CLI}}</div>

              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Fec. Nac. Paciente" prop='FEC_CLI'>
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

                  <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                </div>
                <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

                  <div class="text-center text-danger">NO ESTABLECIDO</div>
                </div>


              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Cod. Doctor" prop='CODN_DOC'>
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].CODN_DOC}}</div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Doctor" prop='NOM_DOC'>
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Fecha registro" prop="fecha">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Tipo" prop="tipo">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

                  <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                </div>
                <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

                  <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                </div>



              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Acciones" prop="Acciones">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row" >


                <div class="text-center"><button class="btn btn-success" (click)="envioImagenesPaciente(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].TEL_CLI,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC,'envio-paciente')"><i class="zmdi zmdi-whatsapp text-white" aria-hidden="true"></i></button></div>


              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Resp." prop="nombre">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                let-row="row">
                <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

                  <div class="text-center">-</div>
                </div>
                <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

                  {{ordenes[rowIndex].numeroFacturaOrden}}
                </div>


              </ng-template>
            </ngx-datatable-column>



          </ngx-datatable>
        </div>
      </ng-template>
    </li>-->
    <!--<li ngbNavItem="5">
    <a ngbNavLink class="" (click)="dtenvioImagenesDoctor()"><i class="fa fa-cube" ></i>&nbsp;Envío imagenes doctor</a>
    <ng-template ngbNavContent>

      <div class="table-responsive">
        <div *ngIf="ordenes.length<=0">
          <p>SIN DATOS</p>
        </div>
        <table *ngIf="ordenes.length>0"   datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">

          <thead>
            <tr>
              <th>#</th>

              <th>Nº Orden</th>
              <th>Paciente</th>
              <th>Celular Paciente</th>
              <th>Fec. Nacimiento Paciente</th>
              <th>Cod. Doctor</th>
              <th>Doctor</th>
              <th>Sucursal</th>
              <th>Fecha de registro</th>
              <th>Tipo</th>
              <th>Fecha de visita</th>

              <th>Acciones</th>



            </tr>
          </thead>
          <tbody>


            <tr   *ngFor="let dt of ordenes; let rowIndex = index;" >
              <td>{{rowIndex+1}}</td>
              <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
              <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !=''">

                <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
              </div>
            </td>

            <td>{{ dt.NOM_CLI }}</td>
            <td>{{ dt.TEL_CLI }} </td>
            <td><div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

              <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
            </div>
            <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

              <div class="text-center text-danger">NO ESTABLECIDO</div>
            </div></td>
            <td>{{ dt.CODN_DOC }}</td>
            <td>{{ dt.NOM_DOC }}</td>
            <td>{{ dt.DIR_SURC }}</td>
            <td>{{ dt.fecha }}</td>
            <td><div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

              <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
            </div>
            <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

              <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
            </div>
          </td>
          <td>{{dt.FEC_ORD}}</td>

          <td>
            <div class="text-center"><button class="btn btn-success" (click)="envioImagenesDoctor(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].CEL_DOC,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC,'envio-doctor')"><i class="zmdi zmdi-whatsapp text-white" aria-hidden="true"></i></button></div>
          </td>

        </tr>
      </tbody>



    </table>
  </div>
</ng-template>
</li>
<li *ngIf="!isMobileView && canVerTabAnuladas" ngbNavItem="6">
  <a ngbNavLink class="" (click)="cambiarEstado('anulado', 'normal')"><i class="fa fa-cube"></i>&nbsp;Anuladas</a>
  <ng-template ngbNavContent>

    <div class="table-responsive">
      <table    datatable [dtOptions]="dtOptionsSN" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">

        <thead>
          <tr>
            <th>#</th>
            <th>Factura</th>
            <th>Nº Orden</th>
            <th>Paciente</th>
            <th>Celular Paciente</th>
            <th>Fec. Nacimiento Paciente</th>
            <th>Cod. Doctor</th>
            <th>Doctor</th>
            <th>Sucursal</th>
            <th>Fecha de registro</th>
            <th>Tipo</th>
            <th>Fecha de visita</th>
            <th>Responsable</th>
            <th>Acciones</th>



          </tr>
        </thead>
        <tbody>


          <tr   *ngFor="let dt of ordenes; let rowIndex = index;" >
            <td>{{dt.id}}</td>
            <td> - </td>
            <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
            <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !=''">

              <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
            </div>
          </td>

          <td>{{ dt.nombre }}</td>
          <td>{{ dt.telefono }} </td>
          <td><div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

            <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
          </div>
          <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

            <div class="text-center text-danger">NO ESTABLECIDO</div>
          </div></td>
          <td>{{ dt.codigoDoctor }}</td>
          <td>{{ dt.nombreDoctor }}</td>
          <td>{{ dt.direccionSucursal }}</td>
          <td>{{ dt.fechaVisita }}</td>
          <td><div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

            <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
          </div>
          <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

            <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
          </div>
        </td>
        <td>{{dt.fechaOrden}}</td>
        <td> - </td>
        <td>

        </td>

      </tr>
    </tbody>



  </table>
  <!--<ngx-datatable #table class='bootstrap' [rows]="ordenes"  columnMode="force"  [headerHeight]="50" [footerHeight]="50"
  rowHeight="auto" [summaryRow]="true" [summaryPosition]="'bottom'"  [externalPaging]="true" [limit]="size" [count]="totalElements"
  [offset]="pageNumber"
  >





  <ngx-datatable-column name="N. Orden" prop='NUM_ORD'>
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
      <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">

        <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Paciente" prop="NOM_CLI"  >
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].NOM_CLI}}</div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Tel. Paciente" prop='TEL_CLI'>
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center"><i class="zmdi zmdi-whatsapp text-success"></i> {{ordenes[rowIndex].TEL_CLI}}</div>

    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Fec. Nac. Paciente" prop='FEC_CLI'>
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

        <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
      </div>
      <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

        <div class="text-center text-danger">NO ESTABLECIDO</div>
      </div>


    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Cod. Doctor" prop='CODN_DOC'>
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].CODN_DOC}}</div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Doctor" prop='NOM_DOC'>
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Fecha registro" prop="fecha">
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Tipo" prop="tipo">
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

        <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
      </div>
      <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

        <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
      </div>



    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
      let-row="row">
      <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
    </ng-template>
  </ngx-datatable-column>




</ngx-datatable>
</div>
</ng-template>
</li>-->
@if (!isMobileView && canVerTabPaquetes) {
  <li ngbNavItem="7">
    <a ngbNavLink class="" (click)="getPaquete()"><i class="fa fa-cube"></i>&nbsp;Paquetes</a>
    <ng-template ngbNavContent>
      @if (posts.length<=0) {
        <div >
          <p>SIN DATOS</p>
        </div>
      }
      @if (posts.length>=1) {
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover mobile-friendly-table packages-table">
          <thead>
            <tr>
              <th>FACTURA N.</th>
              <th>PACIENTE</th>
              <th>MÉTODO PAGO</th>
              <th>TOTAL</th>
              <th>FECHA</th>
              <th>ESTADO PAQUETE</th>
              <th>CÓDIGO DOCTOR</th>
              <th>NOMBRE DOCTOR</th>
              <th>SUCURSAL</th>
              <th>GENERADO POR</th>
              <th>ACCIONES</th>
              <th style="display:none;">CODIGOS_BUSQUEDA</th>
            </tr>
          </thead>
          <tbody>
            @for (post of posts; track post; let i = $index) {
              <tr>
                <td>{{ post.NUM_TRAC }}</td>
                <td>{{ post.NOM_CLI }}</td>
                <td>{{ post.METPAG_TRAC }}</td>
                <td>{{obtenerValor(post.TOTPAG_TRAC )}}</td>
                <td>{{ post.FEC_TRAC }}</td>
                <td>
                  @if (totalSecuencia(post.secuenciaUsada)>=1) {
                    <div>
                      <p class="text-warning">POR COMPLETAR</p>
                    </div>
                  }
                  @if (totalSecuencia(post.secuenciaUsada) <=0) {
                    <div>
                      <p class="text-success">COMPLETADO</p>
                    </div>
                  }
                </td>
                <td>{{post.codigoDoctorOrd}}</td>
                <td>{{post.OBS_TRAC}}</td>
                <td>{{returnSucursal(post.sucursal)}}</td>
                <td>{{post.nombre}}</td>
                <td class="text-center">
                  <button class="btn btn-primary btn-sm" (click)="abrirModalCodigosPaquete(post, mdlCodigosPaquete)" type="button" title="Ver códigos disponibles">
                    <i class="fe fe-list"></i>&nbsp;Ver Códigos
                    <span class="badge badge-light ml-1">
                      @if (post.secuenciaUsada!=null && post.secuenciaUsada!='null') {
                        <span>{{totalSecuencia(post.secuenciaUsada)}}</span>
                      }
                      @if (post.secuenciaUsada==null || post.secuenciaUsada=='null') {
                        <span>{{totalSecuencia(post.DET_TRAC)}}</span>
                      }
                    </span>
                  </button>
                </td>
                <td style="display:none;">{{ getCodigosTexto(post) }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </ng-template>
  </li>
}
<!--<li ngbNavItem="8">
<a ngbNavLink class=""  (click)="cambiarEstado('correo-invalido', 'normal')"><i class="fa fa-cube"></i>&nbsp;Correo inválidos</a>
<ng-template ngbNavContent>

  <div class="table-responsive">
    <table    datatable [dtOptions]="dtOptionsSN" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">

      <thead>
        <tr>
          <th>#</th>
          <th>Factura</th>
          <th>Nº Orden</th>
          <th>Paciente</th>
          <th>Celular Paciente</th>
          <th>Fec. Nacimiento Paciente</th>
          <th>Cod. Doctor</th>
          <th>Doctor</th>
          <th>Sucursal</th>
          <th>Fecha de registro</th>
          <th>Tipo</th>
          <th>Fecha de visita</th>
          <th>Responsable</th>
          <th>Acciones</th>



        </tr>
      </thead>
      <tbody>


        <tr   *ngFor="let dt of ordenes; let rowIndex = index;" >
          <td>{{dt.id}}</td>
          <td>{{dt.factura}}</td>
          <td><div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
          <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !=''">

            <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
          </div>
        </td>

        <td>{{ dt.nombre }}</td>
        <td>{{ dt.telefono }} </td>
        <td><div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

          <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
        </div>
        <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

          <div class="text-center text-danger">NO ESTABLECIDO</div>
        </div></td>
        <td>{{ dt.codigoDoctor }}</td>
        <td>{{ dt.nombreDoctor }}</td>
        <td>{{ dt.direccionSucursal }}</td>
        <td>{{ dt.fechaVisita }}</td>
        <td><div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

          <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
        </div>
        <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

          <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
        </div>
      </td>
      <td>{{dt.fechaOrden}}</td>
      <td>{{dt.responsable}}</td>
      <td>
        <ng-container *ngIf="isMobileView">
          <ng-container *ngTemplateOutlet="mobileUploadButton; context: { orderId: ordenes[rowIndex].COD_ORD, hasFile: !!ordenes[rowIndex].ordenFisica }"></ng-container>
          <button
            *ngIf="ordenes[rowIndex].ordenFisica"
            type="button"
            class="btn btn-outline-secondary btn-sm w-100 mt-2 mobile-view-btn"
            (click)="viewExistingMobilePreview(ordenes[rowIndex].ordenFisica)"
            >
            <i class="fa fa-eye me-1"></i> Ver foto subida
          </button>
        </ng-container>
        <div *ngIf="!isMobileView" ngbDropdown container="body">

          <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">

            <i class="fe fe-settings"></i>

          </button>


          <div class="tx-13" ngbDropdownMenu>
            <div>
              <a ngbDropdownItem href="javascript:;" (click)="modificarCorreo(mdlModificarCorreo,ordenes[rowIndex].CODN_DOC, ordenes[rowIndex].COD_ORD)">
                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;MODIFICAR CORREO</b>
              </a>
            </div>
            <div *ngIf="ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null' ||  ordenes[rowIndex].secuenciaOrden ==''">
              <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
              </a>
            </div>


            <div>
              <div *ngIf="ordenes[rowIndex].NOTPACIMG_ORD ==null ||  ordenes[rowIndex].NOTPACIMG_ORD =='null' || ordenes[rowIndex].NOTPACIMG_ORD ==''">
                <a ngbDropdownItem href="javascript:;"  (click)="envioResultados(ordenes[rowIndex].COD_ORD, 'paciente')">


                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR RESULTADOS A PACIENTE</b>
                </a>
              </div>

            </div>
            <div>
              <div>
                <a ngbDropdownItem href="javascript:;"  (click)="envioResultados(ordenes[rowIndex].COD_ORD, 'doctor')">


                  <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;REENVIAR RESULTADOS A DOCTOR</b>
                </a>
              </div>

            </div>
            <div>
              <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
                <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
              </a>
            </div>

            <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">
              <a ngbDropdownItem href="javascript:;"  (click)="eliminarSecuenciaFisica(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].secuenciaOrden )">
                <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR SECUENCIA FISICA</b>
              </a>
            </div>

            <div *ngIf="modifyDoctor.includes(codeUserModify)">
              <a ngbDropdownItem href="javascript:;" (click)="modificarDoctor(mdlModificarDoctor,ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].secuenciaOrden, ordenes[rowIndex].nombreDoctor)">
                <i class="zmdi zmdi-collection-text text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;MODIFICAR DOCTOR</b>
              </a>
            </div>






          </div>


        </div>

      </td>



    </tr>
  </tbody>



</table>

<!--<ngx-datatable #table class='bootstrap' [rows]="ordenes"  columnMode="force"  [headerHeight]="50" [footerHeight]="50"
rowHeight="auto" [summaryRow]="true" [summaryPosition]="'bottom'"  [externalPaging]="true" [limit]="size" [count]="totalElements"
[offset]="pageNumber"
>





<ngx-datatable-column name="N. Orden" prop='NUM_ORD'>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
    <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">

      <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
    </div>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Paciente" prop="NOM_CLI"  >
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].NOM_CLI}}</div>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Tel. Paciente" prop='TEL_CLI'>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center"><i class="zmdi zmdi-whatsapp text-success"></i> {{ordenes[rowIndex].TEL_CLI}}</div>

  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Fec. Nac. Paciente" prop='FEC_CLI'>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div *ngIf="ordenes[rowIndex].FEC_CLI !== null">

      <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
    </div>
    <div *ngIf="ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null'">

      <div class="text-center text-danger">NO ESTABLECIDO</div>
    </div>


  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Cod. Doctor" prop='CODN_DOC'>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].CODN_DOC}}</div>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Doctor" prop='NOM_DOC'>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Fecha registro" prop="fecha">
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="Tipo" prop="tipo">
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">

      <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
    </div>
    <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">

      <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
    </div>



  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
  </ng-template>
</ngx-datatable-column>
<ngx-datatable-column name="Acciones" prop="Acciones">
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row" >



    <div ngbDropdown container="body">

      <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">

        <i class="fe fe-settings"></i>

      </button>


      <div class="tx-13" ngbDropdownMenu>

        <div *ngIf="ordenes[rowIndex].secuenciaOrden ==null ||  ordenes[rowIndex].secuenciaOrden =='null'">
          <a ngbDropdownItem href="javascript:;" (click)="modalAsignarOrden(mdlAsignarOrden,ordenes[rowIndex].COD_ORD, ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI)">
            <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR SECUENCIA FISICA</b>
          </a>
        </div>


        <div>
          <div *ngIf="ordenes[rowIndex].NOTPACIMG_ORD ==null ||  ordenes[rowIndex].NOTPACIMG_ORD =='null' || ordenes[rowIndex].NOTPACIMG_ORD ==''">
            <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesPaciente(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].TEL_CLI,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


              <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A PACIENTE (0)</b>
            </a>
          </div>
          <div *ngIf="ordenes[rowIndex].NOTPACIMG_ORD !=null  &&  ordenes[rowIndex].NOTPACIMG_ORD !='null' && ordenes[rowIndex].NOTPACIMG_ORD !=''">
            <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesPaciente(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].TEL_CLI,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


              <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A PACIENTE ({{ordenes[rowIndex].NOTPACIMG_ORD}})</b>
            </a>
          </div>

        </div>
        <div>
          <div *ngIf="ordenes[rowIndex].NOTDOCIMG_ORD ==null ||  ordenes[rowIndex].NOTDOCIMG_ORD =='null' || ordenes[rowIndex].NOTDOCIMG_ORD ==''">
            <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesDoctor(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].CEL_DOC,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


              <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A DOCTOR (0)</b>
            </a>
          </div>
          <div *ngIf="ordenes[rowIndex].NOTDOCIMG_ORD !=null  &&  ordenes[rowIndex].NOTDOCIMG_ORD !='null' && ordenes[rowIndex].NOTDOCIMG_ORD !=''">
            <a ngbDropdownItem href="javascript:;"  (click)="envioImagenesDoctor(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].CEL_DOC,ordenes[rowIndex].COD_SURC,ordenes[rowIndex].DIR_SURC, 'con-imagenes')">


              <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR IMÁGENES A DOCTOR ({{ordenes[rowIndex].NOTDOCIMG_ORD}})</b>
            </a>
          </div>
        </div>
        <div>
          <a ngbDropdownItem href="javascript:;" (click)="imprimirOrden(ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].NOM_DOC,ordenes[rowIndex].TEL_DOC)">
            <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;IMPRIMIR</b>
          </a>
        </div>

        <div *ngIf="ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'">
          <a ngbDropdownItem href="javascript:;"  (click)="eliminarSecuenciaFisica(ordenes[rowIndex].COD_ORD,ordenes[rowIndex].secuenciaOrden )">
            <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR SECUENCIA FISICA</b>
          </a>
        </div>

        <div>
          <a ngbDropdownItem href="javascript:;" (click)="modificarDoctor(mdlModificarDoctor,ordenes[rowIndex].NUM_ORD, ordenes[rowIndex].COD_ORD, ordenes[rowIndex].secuenciaOrden)">
            <i class="zmdi zmdi-collection-text text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;MODIFICAR DOCTOR</b>
          </a>
        </div>


        <div>
          <a ngbDropdownItem href="javascript:;" (click)="modificarCorreo(mdlModificarCorreo,ordenes[rowIndex].CODN_DOC, ordenes[rowIndex].COD_ORD)">
            <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i>  <b>&nbsp;&nbsp;MODIFICAR CORREO</b>
          </a>
        </div>


      </div>


    </div>

  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column name="Resp." prop="nombre">
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
    let-row="row">
    <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">

      <div class="text-center">-</div>
    </div>
    <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">

      {{ordenes[rowIndex].numeroFacturaOrden}}
    </div>


  </ng-template>
</ngx-datatable-column>



</ngx-datatable>
</div>
</ng-template>
</li>-->
@if (!isMobileView && canVerTabTomografiaDicom) {
  <li ngbNavItem="9">
    <a ngbNavLink class=""  (click)="dtTomografiaDicom()"><i class="fa fa-cube"></i>&nbsp;Tomografía Dicom</a>
    <ng-template ngbNavContent>
      <!-- Barra de búsqueda -->
      <div class="d-flex align-items-center mb-3 gap-2 flex-wrap">
        <div class="input-group" style="max-width:360px">
          <span class="input-group-text"><i class="fe fe-search"></i></span>
          <input type="text" class="form-control" placeholder="Buscar paciente, doctor, orden..."
            [(ngModel)]="busquedaTom" (input)="filtrarTom()">
          @if (busquedaTom) {
            <button class="btn btn-outline-secondary" type="button" (click)="busquedaTom=''; filtrarTom()">
              <i class="fe fe-x"></i>
            </button>
          }
        </div>
        <small class="text-muted">
          {{ totalTom }} resultado(s)
          @if (spinnerBoolean) { <span class="spinner-border spinner-border-sm ms-1"></span> }
        </small>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover mobile-friendly-table orders-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Factura</th>
              <th>Nº Orden</th>
              <th>Paciente</th>
              <th>Celular Paciente</th>
              <th>Fec. Nacimiento Paciente</th>
              <th>Cod. Doctor</th>
              <th>Doctor</th>
              <th>Sucursal</th>
              <th>Fecha de registro</th>
              <th>Tipo</th>
              <th>Responsable</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            @for (dt of ordenesTomPaginadas; track dt.COD_ORD; let rowIndex = $index) {
              <tr>
                <td>{{ (paginaTom - 1) * itemsPorPaginaTom + rowIndex + 1 }}</td>
                <td>{{ dt.numeroFacturaOrden }}</td>
                <td>
                  <div class="text-center">{{ dt.NUM_ORD }}</div>
                  @if (dt.secuenciaOrden != null && dt.secuenciaOrden != 'null' && dt.secuenciaOrden != '') {
                    <div class="text-center"><b>SF:</b> <span class="text-success">{{ dt.secuenciaOrden }}</span></div>
                  }
                </td>
                <td>{{ dt.NOM_CLI }}</td>
                <td>{{ dt.TEL_CLI }}</td>
                <td>
                  @if (dt.FEC_CLI !== null && dt.FEC_CLI !== '' && dt.FEC_CLI !== 'null') {
                    <div class="text-center">{{ dt.FEC_CLI }}</div>
                  } @else {
                    <div class="text-center text-danger">NO ESTABLECIDO</div>
                  }
                </td>
                <td>{{ dt.CODN_DOC }}</td>
                <td>{{ dt.NOM_DOC }}</td>
                <td>{{ dt.DIR_SURC }}</td>
                <td>{{ dt.fecha }}</td>
                <td>
                  @if (dt.tipo === 'WEB') {
                    <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                  }
                  @if (dt.tipo === 'MOVIL') {
                    <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                  }
                </td>
                <td>{{ dt.responsable }}</td>
                <td>
                  <div ngbDropdown container="body">
                    <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                      <i class="fe fe-settings"></i>
                    </button>
                    <div class="tx-13" ngbDropdownMenu>
                      @if (dt.NOTPACIMGTOMDIC_ORD <= 1) {
                        <a ngbDropdownItem href="javascript:;" (click)="enviarTomografiaEmail(dt.COD_ORD,'NOTPACIMGTOMDIC_ORD','dicon',dt.CODN_DOC,dt.NOM_CLI,dt.NUM_ORD)">
                          <i class="zmdi zmdi-email text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA EMAIL</b>
                        </a>
                      }
                      @if (dt.WSNOTPACIMGTOMDIC_ORD <= 1) {
                        <a ngbDropdownItem href="javascript:;" (click)="enviarWSEmail(dt.COD_ORD,'WSNOTPACIMGTOMDIC_ORD','noramal',dt.CODN_DOC,dt.NOM_CLI,dt.NUM_ORD)">
                          <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA WHATSAPP</b>
                        </a>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
            @if (ordenesTomPaginadas.length === 0 && !spinnerBoolean) {
              <tr><td colspan="14" class="text-center text-muted py-4">Sin resultados</td></tr>
            }
          </tbody>
        </table>
      </div>
      @if (totalPaginasTom > 1) {
        <nav aria-label="Paginación tomografía" class="mt-3">
          <ul class="pagination justify-content-end mb-0 flex-wrap">
            <li class="page-item" [class.disabled]="paginaTom <= 1">
              <a class="page-link" href="javascript:;" (click)="irPaginaTom(paginaTom - 1)">&lsaquo;</a>
            </li>
            @for (p of getPageRangeTom(); track p) {
              @if (p === '...') {
                <li class="page-item disabled"><span class="page-link">&hellip;</span></li>
              } @else {
                <li class="page-item" [class.active]="p === paginaTom">
                  <a class="page-link" href="javascript:;" (click)="irPaginaTom(+p)">{{ p }}</a>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="paginaTom >= totalPaginasTom">
              <a class="page-link" href="javascript:;" (click)="irPaginaTom(paginaTom + 1)">&rsaquo;</a>
            </li>
          </ul>
        </nav>
      }
    <!--REMOVED ngx-datatable (unused) -->
    <!--<ngx-datatable name="Sucursal" prop='DIR_SURC'>
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Fecha registro" prop="fecha">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Tipo" prop="tipo">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">
          <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
        </div>
        <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">
          <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Acciones" prop="Acciones">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row" >
        <div ngbDropdown container="body">
          <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
            <i class="fe fe-settings"></i>
          </button>
          <div class="tx-13" ngbDropdownMenu>
            <div *ngIf="ordenes[rowIndex].NOTPACIMGTOMDIC_ORD<=1">
              <a ngbDropdownItem href="javascript:;" (click)="enviarTomografiaEmail(ordenes[rowIndex].COD_ORD,'NOTPACIMGTOMDIC_ORD' ,'dicon',ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD)">
                <i class="zmdi zmdi-email text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA EMAIL</b>
              </a>
            </div>
            <div *ngIf="ordenes[rowIndex].WSNOTPACIMGTOMDIC_ORD<=1">
              <a ngbDropdownItem href="javascript:;" (click)="enviarWSEmail(ordenes[rowIndex].COD_ORD,'WSNOTPACIMGTOMDIC_ORD' ,'noramal',ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD)">
                <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA WHATSAPP</b>
              </a>
            </div>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Resp." prop="nombre">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">
          <div class="text-center">-</div>
        </div>
        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">
          {{ordenes[rowIndex].numeroFacturaOrden}}
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>-->
</ng-template>
</li>
}
@if (!isMobileView && canVerTabTomografia) {
  <li ngbNavItem="10">
    <a ngbNavLink class=""  (click)="dtTomografia()"><i class="fa fa-cube"></i>&nbsp;Tomografía</a>
    <ng-template ngbNavContent>
      <!-- Barra de búsqueda -->
      <div class="d-flex align-items-center mb-3 gap-2 flex-wrap">
        <div class="input-group" style="max-width:360px">
          <span class="input-group-text"><i class="fe fe-search"></i></span>
          <input type="text" class="form-control" placeholder="Buscar paciente, doctor, orden..."
            [(ngModel)]="busquedaTom" (input)="filtrarTom()">
          @if (busquedaTom) {
            <button class="btn btn-outline-secondary" type="button" (click)="busquedaTom=''; filtrarTom()">
              <i class="fe fe-x"></i>
            </button>
          }
        </div>
        <small class="text-muted">
          {{ totalTom }} resultado(s)
          @if (spinnerBoolean) { <span class="spinner-border spinner-border-sm ms-1"></span> }
        </small>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover mobile-friendly-table orders-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Factura</th>
              <th>Nº Orden</th>
              <th>Paciente</th>
              <th>Celular Paciente</th>
              <th>Fec. Nacimiento Paciente</th>
              <th>Cod. Doctor</th>
              <th>Doctor</th>
              <th>Sucursal</th>
              <th>Fecha de registro</th>
              <th>Tipo</th>
              <th>Responsable</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            @for (dt of ordenesTomPaginadas; track dt.COD_ORD; let rowIndex = $index) {
              <tr>
                <td>{{ (paginaTom - 1) * itemsPorPaginaTom + rowIndex + 1 }}</td>
                <td>{{ dt.numeroFacturaOrden }}</td>
                <td>
                  <div class="text-center">{{ dt.NUM_ORD }}</div>
                  @if (dt.secuenciaOrden != null && dt.secuenciaOrden != 'null' && dt.secuenciaOrden != '') {
                    <div class="text-center"><b>SF:</b> <span class="text-success">{{ dt.secuenciaOrden }}</span></div>
                  }
                </td>
                <td>{{ dt.NOM_CLI }}</td>
                <td>{{ dt.TEL_CLI }}</td>
                <td>
                  @if (dt.FEC_CLI !== null && dt.FEC_CLI !== '' && dt.FEC_CLI !== 'null') {
                    <div class="text-center">{{ dt.FEC_CLI }}</div>
                  } @else {
                    <div class="text-center text-danger">NO ESTABLECIDO</div>
                  }
                </td>
                <td>{{ dt.CODN_DOC }}</td>
                <td>{{ dt.NOM_DOC }}</td>
                <td>{{ dt.DIR_SURC }}</td>
                <td>{{ dt.fecha }}</td>
                <td>
                  @if (dt.tipo === 'WEB') {
                    <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                  }
                  @if (dt.tipo === 'MOVIL') {
                    <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                  }
                </td>
                <td>{{ dt.responsable }}</td>
                <td>
                  <div ngbDropdown container="body">
                    <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                      <i class="fe fe-settings"></i>
                    </button>
                    <div class="tx-13" ngbDropdownMenu>
                      @if (dt.NOTDOCIMGTOM_ORD <= 1) {
                        <a ngbDropdownItem href="javascript:;" (click)="enviarTomografiaEmailNormal(dt.COD_ORD,'NOTDOCIMGTOM_ORD','dicon',dt.CODN_DOC,dt.NOM_CLI,dt.NUM_ORD,dt.LINKTOM_ORD)">
                          <i class="zmdi zmdi-email text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA EMAIL</b>
                        </a>
                      }
                      @if (dt.WSNOTDOCIMGTOM_ORD <= 1) {
                        <a ngbDropdownItem href="javascript:;" (click)="enviarWSEmailNormal(dt.COD_ORD,'WSNOTDOCIMGTOM_ORD','noramal',dt.CODN_DOC,dt.NOM_CLI,dt.NUM_ORD,dt.LINKTOM_ORD)">
                          <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA WHATSAPP</b>
                        </a>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
            @if (ordenesTomPaginadas.length === 0 && !spinnerBoolean) {
              <tr><td colspan="14" class="text-center text-muted py-4">Sin resultados</td></tr>
            }
          </tbody>
        </table>
      </div>
      @if (totalPaginasTom > 1) {
        <nav aria-label="Paginación tomografía" class="mt-3">
          <ul class="pagination justify-content-end mb-0 flex-wrap">
            <li class="page-item" [class.disabled]="paginaTom <= 1">
              <a class="page-link" href="javascript:;" (click)="irPaginaTom(paginaTom - 1)">&lsaquo;</a>
            </li>
            @for (p of getPageRangeTom(); track p) {
              @if (p === '...') {
                <li class="page-item disabled"><span class="page-link">&hellip;</span></li>
              } @else {
                <li class="page-item" [class.active]="p === paginaTom">
                  <a class="page-link" href="javascript:;" (click)="irPaginaTom(+p)">{{ p }}</a>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="paginaTom >= totalPaginasTom">
              <a class="page-link" href="javascript:;" (click)="irPaginaTom(paginaTom + 1)">&rsaquo;</a>
            </li>
          </ul>
        </nav>
      }
    <!--<ngx-datatable name="Doctor" prop='NOM_DOC'>
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].NOM_DOC}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Sucursal" prop='DIR_SURC'>
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].DIR_SURC}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Fecha registro" prop="fecha">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].fecha  | date :'yyyy-MM-dd h:mm:ss a'}} </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Tipo" prop="tipo">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div *ngIf="ordenes[rowIndex].tipo === 'WEB'">
          <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
        </div>
        <div *ngIf="ordenes[rowIndex].tipo === 'MOVIL'">
          <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Fecha visita" prop="FEC_ORD">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div class="text-center">{{ordenes[rowIndex].FEC_ORD}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Acciones" prop="Acciones">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row" >
        <div ngbDropdown container="body">
          <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
            <i class="fe fe-settings"></i>
          </button>
          <div class="tx-13" ngbDropdownMenu>
            <div *ngIf="ordenes[rowIndex].NOTDOCIMGTOM_ORD<=1">
              <a ngbDropdownItem href="javascript:;" (click)="enviarTomografiaEmailNormal(ordenes[rowIndex].COD_ORD,'NOTDOCIMGTOM_ORD' ,'normal',ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].LINKTOM_ORD)">
                <i class="zmdi zmdi-email text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA EMAIL</b>
              </a>
            </div>
            <div *ngIf="ordenes[rowIndex].WSNOTDOCIMGTOM_ORD<=1">
              <a ngbDropdownItem href="javascript:;" (click)="enviarWSEmailNormal(ordenes[rowIndex].COD_ORD,'WSNOTDOCIMGTOM_ORD' ,'normal',ordenes[rowIndex].CODN_DOC,ordenes[rowIndex].NOM_CLI,ordenes[rowIndex].NUM_ORD,ordenes[rowIndex].LINKTOM_ORD)">
                <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR TOMOGRAFIA WHATSAPP</b>
              </a>
            </div>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Resp." prop="nombre">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
        let-row="row">
        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden === null">
          <div class="text-center">-</div>
        </div>
        <div *ngIf="ordenes[rowIndex].numeroFacturaOrden !== ''">
          {{ordenes[rowIndex].numeroFacturaOrden}}
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>-->
</ng-template>
</li>
}
@if (!isMobileView && mostrarCitaPrevia) {
  <li ngbNavItem="12">
    <a ngbNavLink class="" (click)="dtPendienteCitaPrevia('pendiente')" ><i class="fa fa-cube"></i>&nbsp;Citas Previas</a>
    <ng-template ngbNavContent>
      <div class="tab-menu-heading">
        <div class="tabs-menu">
          <ul ngbNav #navCitas="ngbNav" class="nav panel-tabs" orientation="horizantal">
            @if (!isMobileView) {
              <li ngbNavItem="1" >
                <a ngbNavLink class="" (click)="dtPendienteCitaPrevia('pendiente')"><i class="fa fa-cube"></i>&nbsp; Pendientes</a>
                <ng-template ngbNavContent>
                  <div class="table-responsive">
                    <table  datatable [dtOptions]="dtOptionsCitaPendiente" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Factura</th>
                          <th>Nº Orden</th>
                          <th>Paciente</th>
                          <th>Celular Paciente</th>
                          <th>Fec. Nacimiento Paciente</th>
                          <th>Cod. Doctor</th>
                          <th>Doctor</th>
                          <th>Sucursal</th>
                          <th>Fecha de registro</th>
                          <th>Tipo</th>
                          <th>Fecha de visita</th>
                          <th>Responsable</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (dt of ordenesPendienteCita; track dt; let rowIndex = $index) {
                          <tr>
                            <td>{{dt.id}}</td>
                            <td> - </td>
                            <td>
                              <div class="text-center">{{ordenesPendienteCita[rowIndex].NUM_ORD}} </div>
                              @if (ordenesPendienteCita[rowIndex].secuenciaOrden !=null &&  ordenesPendienteCita[rowIndex].secuenciaOrden !='null'  &&  ordenesPendienteCita[rowIndex].secuenciaOrden !='') {
                                <div
                                  >
                                  <div class="text-center"><b>SF:</b>
                                  <p class="text-success">{{ordenesPendienteCita[rowIndex].secuenciaOrden}}</p>
                                </div>
                              </div>
                            }
                          </td>
                          <td>{{ dt.nombre }}</td>
                          <td>{{ dt.telefono }} </td>
                          <td>
                            @if (ordenesPendienteCita[rowIndex].FEC_CLI !== null) {
                              <div>
                                <div class="text-center">{{ordenesPendienteCita[rowIndex].FEC_CLI}}</div>
                              </div>
                            }
                            @if (ordenesPendienteCita[rowIndex].FEC_CLI ==null || ordenesPendienteCita[rowIndex].FEC_CLI =='' || ordenesPendienteCita[rowIndex].FEC_CLI =='null') {
                              <div
                                >
                                <div class="text-center text-danger">NO ESTABLECIDO</div>
                              </div>
                            }
                          </td>
                          <td>{{ dt.codigoDoctor }}</td>
                          <td>{{ dt.nombreDoctor }}</td>
                          <td>{{ dt.direccionSucursal }}</td>
                          <td>{{ dt.fechaVisita }}</td>
                          <td>
                            @if (ordenesPendienteCita[rowIndex].tipo === 'WEB') {
                              <div>
                                <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                              </div>
                            }
                            @if (ordenesPendienteCita[rowIndex].tipo === 'MOVIL') {
                              <div>
                                <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                              </div>
                            }
                          </td>
                          <td>{{dt.fechaOrden}}</td>
                          <td> - </td>
                          <td>
                            <div ngbDropdown container="body">
                              <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                <i class="fe fe-settings"></i>
                              </button>
                              <div class="tx-13" ngbDropdownMenu>
                                @if (ordenesPendienteCita[rowIndex].secuenciaOrden ==null ||  ordenesPendienteCita[rowIndex].secuenciaOrden =='null' ||  ordenesPendienteCita[rowIndex].secuenciaOrden =='') {
                                  <div
                                    >
                                    <a ngbDropdownItem href="javascript:;"
                                      (click)="modalAsignarOrden(mdlAsignarOrden,ordenesPendienteCita[rowIndex].COD_ORD, ordenesPendienteCita[rowIndex].CODN_DOC,ordenesPendienteCita[rowIndex].NOM_DOC,ordenesPendienteCita[rowIndex].NOM_CLI)">
                                      <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR
                                    SECUENCIA FISICA</b>
                                  </a>
                                </div>
                              }
                              <a ngbDropdownItem href="javascript:;"
                                (click)="enviarAccesosWSPaciente(ordenesPendienteCita[rowIndex].NOM_CLI,ordenesPendienteCita[rowIndex].CED_CLI, ordenesPendienteCita[rowIndex].TEL_CLI)">
                                <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR
                              ACCESOS A PACIENTE</b>
                            </a>
                            <div>
                              <a ngbDropdownItem href="javascript:;"
                                (click)="editarOrden(ordenesPendienteCita[rowIndex].COD_ORD)">
                                <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;EDITAR</b>
                              </a>
                            </div>
                            <div>
                              <a ngbDropdownItem href="javascript:;"
                                (click)="facturarOrden(ordenesPendienteCita[rowIndex].COD_ORD)">
                                <i class="fab fa-wpforms text-info" aria-hidden="true"></i> <b>&nbsp;&nbsp;FACTURAR</b>
                              </a>
                            </div>
                            <div>
                              @if (ordenesPendienteCita[rowIndex].NOTPAC_ORD ==null ||  ordenesPendienteCita[rowIndex].NOTPAC_ORD =='null' || ordenesPendienteCita[rowIndex].NOTPAC_ORD =='') {
                                <div
                                  >
                                  <a ngbDropdownItem href="javascript:;"
                                    (click)="notificarPendientePac(ordenesPendienteCita[rowIndex].COD_ORD, ordenesPendienteCita[rowIndex].NOM_DOC, ordenesPendienteCita[rowIndex].CEL_DOC, ordenesPendienteCita[rowIndex].NOM_CLI, ordenesPendienteCita[rowIndex].TEL_CLI, ordenesPendienteCita[rowIndex].NUM_ORD)">
                                    <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i>
                                    <b>&nbsp;&nbsp;NOTIFICAR PACIENTE (0)</b>
                                  </a>
                                </div>
                              }
                              @if (ordenesPendienteCita[rowIndex].NOTPAC_ORD !=null  &&  ordenesPendienteCita[rowIndex].NOTPAC_ORD !='null' && ordenesPendienteCita[rowIndex].NOTPAC_ORD !='') {
                                <div
                                  >
                                  <a ngbDropdownItem href="javascript:;"
                                    (click)="notificarPendientePac(ordenesPendienteCita[rowIndex].COD_ORD, ordenesPendienteCita[rowIndex].NOM_DOC, ordenesPendienteCita[rowIndex].CEL_DOC, ordenesPendienteCita[rowIndex].NOM_CLI, ordenesPendienteCita[rowIndex].TEL_CLI, ordenesPendienteCita[rowIndex].NUM_ORD)">
                                    <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i>
                                    <b>&nbsp;&nbsp;NOTIFICAR PACIENTE
                                    ({{ordenesPendienteCita[rowIndex].NOTPAC_ORD}})</b>
                                  </a>
                                </div>
                              }
                            </div>
                            <div>
                              @if (ordenesPendienteCita[rowIndex].NOTPACORD_ORD ==null ||  ordenesPendienteCita[rowIndex].NOTPACORD_ORD =='null' || ordenesPendienteCita[rowIndex].NOTPACORD_ORD =='') {
                                <div
                                  >
                                  <a ngbDropdownItem href="javascript:;"
                                    (click)="enviarOrdenPac(ordenesPendienteCita[rowIndex].COD_ORD, ordenesPendienteCita[rowIndex].NOM_DOC, ordenesPendienteCita[rowIndex].CEL_DOC, ordenesPendienteCita[rowIndex].NOM_CLI, ordenesPendienteCita[rowIndex].TEL_CLI, ordenesPendienteCita[rowIndex].NUM_ORD)">
                                    <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i>
                                    <b>&nbsp;&nbsp;ENVIAR ORDEN PACIENTE (0)</b>
                                  </a>
                                </div>
                              }
                              @if (ordenesPendienteCita[rowIndex].NOTPACORD_ORD !=null  &&  ordenesPendienteCita[rowIndex].NOTPACORD_ORD !='null' && ordenesPendienteCita[rowIndex].NOTPACORD_ORD !='') {
                                <div
                                  >
                                  <a ngbDropdownItem href="javascript:;"
                                    (click)="enviarOrdenPac(ordenesPendienteCita[rowIndex].COD_ORD, ordenesPendienteCita[rowIndex].NOM_DOC, ordenesPendienteCita[rowIndex].CEL_DOC, ordenesPendienteCita[rowIndex].NOM_CLI, ordenesPendienteCita[rowIndex].TEL_CLI, ordenesPendienteCita[rowIndex].NUM_ORD)">
                                    <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i>
                                    <b>&nbsp;&nbsp;ENVIAR ORDEN PACIENTE
                                    ({{ordenesPendienteCita[rowIndex].NOTPACORD_ORD}})</b>
                                  </a>
                                </div>
                              }
                            </div>
                            <div>
                              <a ngbDropdownItem href="javascript:;"
                                (click)="imprimirOrden(ordenesPendienteCita[rowIndex].NUM_ORD,ordenesPendienteCita[rowIndex].NOM_DOC,ordenesPendienteCita[rowIndex].TEL_DOC)">
                                <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i>
                                <b>&nbsp;&nbsp;IMPRIMIR</b>
                              </a>
                            </div>
                            <div>
                              <a ngbDropdownItem href="javascript:;"
                                (click)="eliminarOrden(ordenesPendienteCita[rowIndex].COD_ORD)">
                                <i class="far fa-trash-alt text-danger" aria-hidden="true"></i>
                                <b>&nbsp;&nbsp;ELIMINAR</b>
                              </a>
                            </div>
                            @if (ordenesPendienteCita[rowIndex].secuenciaOrden !=null &&  ordenesPendienteCita[rowIndex].secuenciaOrden !='null') {
                              <div
                                >
                                <a ngbDropdownItem href="javascript:;"
                                  (click)="eliminarSecuenciaFisica(ordenesPendienteCita[rowIndex].COD_ORD,ordenesPendienteCita[rowIndex].secuenciaOrden )">
                                  <i class="far fa-trash-alt text-danger" aria-hidden="true"></i> <b>&nbsp;&nbsp;ELIMINAR
                                SECUENCIA FISICA</b>
                              </a>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </ng-template>
      </li>
    }
    @if (!isMobileView) {
      <li ngbNavItem="2">
        <a ngbNavLink class="" (click)="dtFacturadasCitaPrevia('facturadas')"><i class="fa fa-th-large"></i>&nbsp; Facturadas</a>
        <ng-template ngbNavContent>
          <div class="col-12 mb-3">
            <ng-select class="form-control" style="width:20%" [(ngModel)]="tipoVistaCitaPrevia" (change)="cambiarVisualizacionCitas($event)">
              <ng-option value="vista-tabla" >Vista Tabla</ng-option>
              <ng-option value="calendario">Calendario</ng-option>
            </ng-select>
          </div>
          @if (mostrarTipoVisualizacion) {
            <div class="table-responsive">
              <table   datatable [dtOptions]="dtOptionsFacturadasCita" class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table orders-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Factura</th>
                    <th>Nº Orden</th>
                    <th>Paciente</th>
                    <th>Celular Paciente</th>
                    <th>Fec. Nacimiento Paciente</th>
                    <th>Cod. Doctor</th>
                    <th>Doctor</th>
                    <th>Sucursal</th>
                    <th>Fecha de registro</th>
                    <th>Tipo</th>
                    <th>Fecha de visita</th>
                    <th>Responsable</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (dt of ordenesFacturadasCita; track dt; let rowIndex = $index) {
                    <tr>
                      <td>{{dt.id}}</td>
                      <td>{{dt.factura}}</td>
                      <td>
                        <div class="text-center">{{ordenesFacturadasCita[rowIndex].NUM_ORD}} </div>
                        @if (ordenesFacturadasCita[rowIndex].secuenciaOrden !=null &&  ordenesFacturadasCita[rowIndex].secuenciaOrden !='null'  &&  ordenesFacturadasCita[rowIndex].secuenciaOrden !='') {
                          <div
                            >
                            <div class="text-center"><b>SF:</b>
                            <p class="text-success">{{ordenesFacturadasCita[rowIndex].secuenciaOrden}}</p>
                          </div>
                        </div>
                      }
                    </td>
                    <td>{{ dt.nombre }}</td>
                    <td>{{ dt.telefono }} </td>
                    <td>
                      @if (ordenesFacturadasCita[rowIndex].FEC_CLI !== null) {
                        <div>
                          <div class="text-center">{{ordenesFacturadasCita[rowIndex].FEC_CLI}}</div>
                        </div>
                      }
                      @if (ordenesFacturadasCita[rowIndex].FEC_CLI ==null || ordenesFacturadasCita[rowIndex].FEC_CLI =='' || ordenesFacturadasCita[rowIndex].FEC_CLI =='null') {
                        <div
                          >
                          <div class="text-center text-danger">NO ESTABLECIDO</div>
                        </div>
                      }
                    </td>
                    <td>{{ dt.codigoDoctor }}</td>
                    <td>{{ dt.nombreDoctor }}</td>
                    <td>{{ dt.direccionSucursal }}
                      @if (dt.SUCVIST_ORD) {
                        <div class="text-success">Cita: {{ dt.SUCVIST_ORD }}</div>
                      }
                    </td>
                    <td>{{ dt.fechaVisita }}</td>
                    <td>
                      @if (ordenesFacturadasCita[rowIndex].tipo === 'WEB') {
                        <div>
                          <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                        </div>
                      }
                      @if (ordenesFacturadasCita[rowIndex].tipo === 'MOVIL') {
                        <div>
                          <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                        </div>
                      }
                    </td>
                    <td>{{dt.fechaOrden}}</td>
                    <td>{{dt.responsable}}</td>
                    <td>
                      <div ngbDropdown container="body">
                        <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                          <i class="fe fe-settings"></i>
                        </button>
                        <div class="tx-13" ngbDropdownMenu>
                          <div>
                            <a ngbDropdownItem href="javascript:;" (click)="subirImagenes(ordenesFacturadasCita[rowIndex].COD_ORD)">
                              <i class="far fa-file-image text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;AÑADIR
                            IMÁGENES</b>
                          </a>
                        </div>
                        <a ngbDropdownItem href="javascript:;"
                          (click)="enviarAccesosWSPaciente(ordenesFacturadasCita[rowIndex].NOM_CLI,ordenesFacturadasCita[rowIndex].CED_CLI, ordenesFacturadasCita[rowIndex].TEL_CLI)">
                          <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR
                        ACCESOS A PACIENTE</b>
                      </a>
                      <a ngbDropdownItem href="javascript:;"
                        (click)="enviarAccesosWSPaciente(ordenesFacturadasCita[rowIndex].NOM_CLI,ordenesFacturadasCita[rowIndex].CED_CLI, ordenesFacturadasCita[rowIndex].TEL_CLI)">
                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;ENVIAR
                      ACCESOS A PACIENTE</b>
                    </a>
                    @if (ordenesFacturadasCita[rowIndex].secuenciaOrden ==null ||  ordenesFacturadasCita[rowIndex].secuenciaOrden =='null' ||  ordenesFacturadasCita[rowIndex].secuenciaOrden =='') {
                      <div
                        >
                        <a ngbDropdownItem href="javascript:;"
                          (click)="modalAsignarOrden(mdlAsignarOrden,ordenesFacturadasCita[rowIndex].COD_ORD, ordenesFacturadasCita[rowIndex].CODN_DOC,ordenesFacturadasCita[rowIndex].NOM_DOC,ordenesFacturadasCita[rowIndex].NOM_CLI)">
                          <i class="zmdi zmdi-edit text-warning" aria-hidden="true"></i> <b>&nbsp;&nbsp;ASIGNAR
                        SECUENCIA FISICA</b>
                      </a>
                    </div>
                  }
                  <div>
                    <a ngbDropdownItem href="javascript:;"
                      (click)="imprimirOrden(ordenesFacturadasCita[rowIndex].NUM_ORD,ordenesFacturadasCita[rowIndex].NOM_DOC,ordenesFacturadasCita[rowIndex].TEL_DOC)">
                      <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i>
                      <b>&nbsp;&nbsp;IMPRIMIR</b>
                    </a>
                  </div>
                  @if (ordenesFacturadasCita[rowIndex].LAB_ORD == 'laboratorio') {
                    <div>
                      <a ngbDropdownItem href="javascript:;"
                        (click)="imprimirTicketLaboratorio(ordenesFacturadasCita[rowIndex].NUM_ORD)">
                        <i class="zmdi zmdi-collection-pdf text-danger" aria-hidden="true"></i>
                        <b>&nbsp;&nbsp;IMPRIMIR TICKET LABORATORIO</b>
                      </a>
                    </div>
                  }
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (!mostrarTipoVisualizacion) {
  <full-calendar [options]="calendarOptions"></full-calendar>
}
</ng-template>
</li>
}
</ul>
</div>
</div>
<div class="panel-body tabs-menu-body">
  <div [ngbNavOutlet]="navCitas" class="tab-pane"></div>
  <div class="tab-content"></div>
</div>
</ng-template>
</li>
}


</ul>
</div>
</div>
<div class="panel-body tabs-menu-body">
  <div [ngbNavOutlet]="nav3" class="tab-pane"></div>
  <div class="tab-content"></div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

<!-- basic Modal -->

<ng-template #mdlGestionResultados let-modal>
  <div class="modal-header results-modal-header">
    <div class="results-modal-heading">
      <div class="results-modal-heading-icon">
        <i class="zmdi zmdi-folder-person"></i>
      </div>
      <div>
        <h5 class="modal-title">Gestionar resultados</h5>
        <div class="results-modal-order-info">
          <span class="results-modal-order-number">{{ ordenResultadosSeleccionada?.NUM_ORD }}</span>
          <span class="results-modal-patient">{{ ordenResultadosSeleccionada?.NOM_CLI }}</span>
        </div>
      </div>
    </div>
    <button type="button" class="results-modal-close" aria-label="Cerrar" (click)="modal.dismiss()">
      <i class="zmdi zmdi-close"></i>
    </button>
  </div>

  <div class="modal-body results-modal-body">
    @if (enviosResultadosProcesando.size > 0) {
      <div class="results-modal-loading" role="status" aria-live="polite">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span>Enviando, por favor espere...</span>
      </div>
    }
    <fieldset
      class="results-modal-content"
      [class.results-modal-content-loading]="enviosResultadosProcesando.size > 0"
      [disabled]="enviosResultadosProcesando.size > 0">
    <section class="results-modal-section results-modal-section-primary">
      <div class="results-modal-section-title">
        <div>
          <h6 class="mb-1">Reenvío completo</h6>
          <p class="text-muted mb-0">Envía todos los resultados disponibles de la orden.</p>
        </div>
        <span class="badge bg-primary">TODO</span>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 mb-2 mb-md-0">
          <button
            type="button"
            class="btn btn-outline-primary btn-block results-action-button"
            [disabled]="resultadoFueEnviado('completo:paciente')"
            (click)="envioResultados(ordenResultadosSeleccionada.COD_ORD, 'paciente')">
            @if (resultadoFueEnviado('completo:paciente')) {
              <i class="zmdi zmdi-check-circle mr-2"></i>Enviado correctamente
            } @else {
              <i class="zmdi zmdi-account mr-2"></i>Enviar todo al paciente
            }
          </button>
        </div>
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-outline-primary btn-block results-action-button"
            [disabled]="resultadoFueEnviado('completo:doctor')"
            (click)="envioResultados(ordenResultadosSeleccionada.COD_ORD, 'doctor')">
            @if (resultadoFueEnviado('completo:doctor')) {
              <i class="zmdi zmdi-check-circle mr-2"></i>Enviado correctamente
            } @else {
              <i class="zmdi zmdi-account-box mr-2"></i>Enviar todo al doctor
            }
          </button>
        </div>
      </div>
    </section>

    <section class="results-modal-section mt-3">
      <div class="results-modal-section-title">
        <div>
          <h6 class="mb-1">Envíos específicos</h6>
          <p class="text-muted mb-0">Selecciona el tipo de resultado y el canal.</p>
        </div>
      </div>

      @if (ordenResultadosSeleccionada?.TOMO_ORD?.trim().toLowerCase() == 'si') {
        <div class="results-detail-row">
          <div class="results-detail-description">
            <strong>Tomografía</strong>
            <small class="d-block text-muted">Enlace de tomografía convencional</small>
          </div>
          <div class="results-detail-actions">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="resultadoFueEnviado('tomografia:normal:email')"
              (click)="enviarTomografiaEmailAtendidas(ordenResultadosSeleccionada.COD_ORD,'NOTDOCIMGTOM_ORD' ,'noramal',ordenResultadosSeleccionada.CODN_DOC,ordenResultadosSeleccionada.NOM_CLI,ordenResultadosSeleccionada.NUM_ORD,ordenResultadosSeleccionada.LINKTOM_ORD)">
              @if (resultadoFueEnviado('tomografia:normal:email')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-email mr-1"></i>Email ({{ ordenResultadosSeleccionada.NOTDOCIMGTOM_ORD || 0 }})
              }
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-success"
              [disabled]="resultadoFueEnviado('tomografia:normal:whatsapp')"
              (click)="enviarWSEmailAtendidas(ordenResultadosSeleccionada.COD_ORD,'WSNOTDOCIMGTOM_ORD' ,'noramal',ordenResultadosSeleccionada.CODN_DOC,ordenResultadosSeleccionada.NOM_CLI,ordenResultadosSeleccionada.NUM_ORD,ordenResultadosSeleccionada.LINKTOM_ORD)">
              @if (resultadoFueEnviado('tomografia:normal:whatsapp')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-whatsapp mr-1"></i>WhatsApp ({{ ordenResultadosSeleccionada.WSNOTDOCIMGTOM_ORD || 0 }})
              }
            </button>
          </div>
        </div>
      }

      @if (ordenResultadosSeleccionada?.TOMO_ORD?.trim().toLowerCase() == 'si') {
        <div class="results-detail-row">
          <div class="results-detail-description">
            <strong>Tomografía DICOM</strong>
            <small class="d-block text-muted">Enlace del estudio DICOM</small>
          </div>
          <div class="results-detail-actions">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="resultadoFueEnviado('tomografia:dicom:email')"
              (click)="enviarTomografiaEmailAtendidas(ordenResultadosSeleccionada.COD_ORD,'NOTPACIMGTOMDIC_ORD' ,'dicon',ordenResultadosSeleccionada.CODN_DOC,ordenResultadosSeleccionada.NOM_CLI,ordenResultadosSeleccionada.NUM_ORD,ordenResultadosSeleccionada.LINKTOMDIC_ORD)">
              @if (resultadoFueEnviado('tomografia:dicom:email')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-email mr-1"></i>Email ({{ ordenResultadosSeleccionada.NOTPACIMGTOMDIC_ORD || 0 }})
              }
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-success"
              [disabled]="resultadoFueEnviado('tomografia:dicom:whatsapp')"
              (click)="enviarWSEmailAtendidas(ordenResultadosSeleccionada.COD_ORD,'WSNOTPACIMGTOMDIC_ORD' ,'dicon',ordenResultadosSeleccionada.CODN_DOC,ordenResultadosSeleccionada.NOM_CLI,ordenResultadosSeleccionada.NUM_ORD,ordenResultadosSeleccionada.LINKTOMDIC_ORD)">
              @if (resultadoFueEnviado('tomografia:dicom:whatsapp')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-whatsapp mr-1"></i>WhatsApp ({{ ordenResultadosSeleccionada.WSNOTPACIMGTOMDIC_ORD || 0 }})
              }
            </button>
          </div>
        </div>
      }

      @if (ordenResultadosSeleccionada?.LAB_ORD?.trim().toLowerCase() == 'laboratorio') {
        <div class="results-detail-row">
          <div class="results-detail-description">
            <strong>Laboratorio · Doctor</strong>
            <button
              type="button"
              class="btn btn-link btn-sm p-0 d-block"
              (click)="imprimirResultado(
                ordenResultadosSeleccionada.COD_ORD,
                ordenResultadosSeleccionada.FEC_ORD
              )">
              Ver resultados
            </button>
          </div>
          <div class="results-detail-actions">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="resultadoFueEnviado('laboratorio:doctor:email')"
              (click)="enviarResultadosEmail(ordenResultadosSeleccionada.COD_ORD, 'doctor')">
              @if (resultadoFueEnviado('laboratorio:doctor:email')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-email mr-1"></i>Email
              }
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-success"
              [disabled]="resultadoFueEnviado('laboratorio:doctor:whatsapp')"
              (click)="enviarResultadosWS(ordenResultadosSeleccionada.COD_ORD, 'doctor')">
              @if (resultadoFueEnviado('laboratorio:doctor:whatsapp')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-whatsapp mr-1"></i>WhatsApp ({{ ordenResultadosSeleccionada.WSNOTDOCLAB_ORD }})
              }
            </button>
          </div>
        </div>

        <div class="results-detail-row">
          <div class="results-detail-description">
            <strong>Laboratorio · Paciente</strong>
            <small class="d-block text-muted">Resultados finales de laboratorio</small>
          </div>
          <div class="results-detail-actions">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="resultadoFueEnviado('laboratorio:paciente:email')"
              (click)="enviarResultadosEmail(ordenResultadosSeleccionada.COD_ORD, 'paciente')">
              @if (resultadoFueEnviado('laboratorio:paciente:email')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-email mr-1"></i>Email
              }
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-success"
              [disabled]="resultadoFueEnviado('laboratorio:paciente:whatsapp')"
              (click)="enviarResultadosWS(ordenResultadosSeleccionada.COD_ORD, 'paciente')">
              @if (resultadoFueEnviado('laboratorio:paciente:whatsapp')) {
                <i class="zmdi zmdi-check-circle mr-1"></i>Enviado correctamente
              } @else {
                <i class="zmdi zmdi-whatsapp mr-1"></i>WhatsApp ({{ ordenResultadosSeleccionada.NOTPACIMG_ORD }})
              }
            </button>
          </div>
        </div>
      }
    </section>
    </fieldset>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Cerrar</button>
  </div>
</ng-template>

<ng-template #mdlAsignarOrden let-modal>
  <div class="modal-header">
    <h6 class="modal-title">ASIGNAR SECUENCIA FISICA</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">


    <input type="text" class="form-control" [(ngModel)]="atributoSecuencia" placeholder="Ingrese la secuencia">
  </div>
  @if (spinnerBooleanAsignarOrden) {
    <div class="text-center">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <br>
      </div>
    }
    <div class="modal-footer">
      <button type="button" class="btn ripple btn-primary" (click)="asignarSecuencia()">Guardar cambios</button>
      <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Cerrar</button>
    </div>
  </ng-template>

  <!-- ----------------------------------------------------------------------- -->
  <!--                         MODAL MODIFICAR DOCTOR                          -->
  <!-- ----------------------------------------------------------------------- -->
  <ng-template #mdlModificarDoctor let-modal>
    <div class="modal-header">
      <h6 class="modal-title">ACTUALIZAR DOCTOR</h6>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <ng-select class="form-control" id="seleccionarClienteInput" name="seleccionarClienteInput"
        placeholder="Ingrese cédula, nombre, apellido..." style="width: 100%;" name="country"
        (keydown)="buscarDoctor($event)" [(ngModel)]='selectedDoctor'
        (change)="obtenerDoctorSeleccionado(selectedDoctor)">

        @for (obj of doctoreslist; track obj) {
          <ng-option [value]="obj.codigo">
            {{obj.datos}}
          </ng-option>
        }
      </ng-select>
    </div>
    @if (spinnerBooleanAsignarOrden) {
      <div class="text-center">
        <div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <br>
        </div>
      }
      <div class="modal-footer">
        <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Cerrar</button>
        <button type="button" class="btn ripple btn-primary" (click)="updateDoctor()">Guardar cambios</button>

      </div>
    </ng-template>


    <!-- ----------------------------------------------------------------------- -->
    <!--                            MODIFICAR CORREO                             -->
    <!-- ----------------------------------------------------------------------- -->
    <ng-template #mdlModificarCorreo let-modal>
      <div class="modal-header">
        <h6 class="modal-title">ACTUALIZAR CORREO ELECTRÓNICO</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">







        <div class="form-row">
          <div class="col-md-12">
            <b>INGRESE  EL NUEVO CORREO</b>
            <input type="text" class="form-control"    [(ngModel)]='nuevoCorreoElectronico'>


          </div>

        </div>






      </div>
      <div class="modal-footer">
        <button type="button" class="btn ripple btn-primary" (click)="actualizarCorreo()">Guardar</button>
        <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
      </div>
    </ng-template>


    <!-- ----------------------------------------------------------------------- -->
    <!--                        INGRESAR SECUENCIA FISICA                        -->
    <!-- ----------------------------------------------------------------------- -->
    <ng-template #mdlIngresarSecuencia let-modal>
      <div class="modal-header">
        <h6 class="modal-title">SECUENCIA FISICA</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="form-row">
          <div class="col-md-12">
            <p>Para las siguiente secuencias, anteponer el numero 15 en caso de tener el valor mencionado en la orden fisica</p>
            <p><b>DESDE: 1117001 HASTA: 112200</b></p>
            <b>INGRESE LA SECUENCIA</b>
            <input type="text" class="form-control"  [(ngModel)]='selected'>
            <hr>
              @if (pacienteSecuencia!='') {
                <p class="text-danger text-justify">Lo sentimos la secuencia que ud digitó ya se encuentra asignada al paciente <b>{{pacienteSecuencia}}</b> del Doctor(a) <b>{{doctorSecuencia}}</b>, por favor comuníquese con el ASESOR <b>{{asesorSencuencia}}</b>.</p>
              }

            </div>

          </div>


          @if (spinnerBooleanAsignarOrden) {
            <div class="text-center">
              <div class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <br>
              </div>
            }



          </div>
          <div class="modal-footer">
            <button type="button" class="btn ripple btn-primary" (click)="validarSecuenciaFisica()">CREAR ORDEN</button>
            <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
          </div>
        </ng-template>


        <!-- ----------------------------------------------------------------------- -->
        <!--                        INGRESAR SECUENCIA FISICA                        -->
        <!-- ----------------------------------------------------------------------- -->
        <ng-template #mdlIngresarSecuenciaSF let-modal>
          <div class="modal-header">
            <h6 class="modal-title">SECUENCIA FISICA</h6>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">







            <div class="form-row">
              <div class="col-md-12">
                <b>INGRESE LA SECUENCIA</b>
                <input type="text" class="form-control"  [(ngModel)]='selected'>
                <hr>
                  @if (pacienteSecuencia!='') {
                    <p class="text-danger text-justify">Lo sentimos la secuencia que ud digitó ya se encuentra asignada al paciente <b>{{pacienteSecuencia}}</b> del Doctor(a) <b>{{doctorSecuencia}}</b>, por favor comuníquese con el ASESOR <b>{{asesorSencuencia}}</b>.</p>
                  }

                </div>

              </div>


              @if (spinnerBooleanAsignarOrden) {
                <div class="text-center">
                  <div class="spinner-grow" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <br>
                  </div>
                }



              </div>
              <div class="modal-footer">
                <button type="button" class="btn ripple btn-primary" (click)="validarSecuenciaFisicaSF()">CREAR ORDEN</button>
                <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
              </div>
            </ng-template>




                          <ng-template #mdlSubirOrdenFisica let-modal>
                            <div class="modal-header">
                              <h6 class="modal-title">SUBIR ORDEN FISICA</h6>
                              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">

                              <div class="form-row">
                                <div class="col-md-12">

                                  <input type="file" (change)="ordenFisica($event)"><br><br>
                                </div>

                              </div>


                              @if (spinnerBooleanAsignarOrden) {
                                <div class="text-center">
                                  <div class="spinner-grow" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                  <br>
                                  </div>
                                }



                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn ripple btn-primary" (click)="subirOrdenFisica()">GUARDAR</button>
                                <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
                              </div>
                            </ng-template>

                            <ng-template #mobilePreviewModal let-modal>
                              <div class="modal-header">
                                <h6 class="modal-title">Vista previa - Orden Física</h6>
                                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body text-center">
                                @if (mobilePreviewImage) {
                                  <img [src]="mobilePreviewImage" class="img-fluid rounded shadow-sm" alt="Orden Física">
                                }
                              </div>
                              <div class="modal-footer">
                                @if (showDownloadButton) {
                                  <a [href]="mobilePreviewImage" target="_blank" download
                                    class="btn ripple btn-success mr-2">
                                    <i class="fe fe-download mr-1"></i> Descargar
                                  </a>
                                }
                                <button type="button" class="btn ripple btn-primary" (click)="modal.close()">Cerrar</button>
                              </div>
                            </ng-template>

                            <ng-template #mobileUploadingModal>
                              <div class="modal-body text-center py-4">
                                <div class="spinner-border text-primary mb-3" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                                <p class="mb-0">Subiendo foto, por favor espera...</p>
                              </div>
                            </ng-template>

                            <ng-template #mdlAuditoriaSubidas let-modal>
                              <div class="modal-header bg-dark">
                                <div>
                                  <h6 class="modal-title mb-0 text-white">
                                    <i class="fa fa-history mr-2"></i> Auditoría de imágenes
                                  </h6>
                                  <small class="text-white-50">Historial de cargas realizadas para esta orden</small>
                                </div>
                                <button type="button" class="close text-white" aria-label="Close" (click)="modal.dismiss()">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <div class="alert alert-info py-2 mb-3">
                                  Mostrando todo el rastreo de cargas correspondiente a la orden <strong>{{ auditoriaNumeroOrdenSeleccionada }}</strong>.
                                </div>

                                @if (auditoriaCargando) {
                                  <div class="text-center py-5">
                                    <div class="spinner-border text-primary" role="status"></div>
                                    <p class="mt-2 mb-0">Consultando auditoría...</p>
                                  </div>
                                } @else {
                                  <div class="table-responsive">
                                    <table class="table table-bordered table-hover table-sm auditoria-table">
                                      <thead class="thead-light">
                                        <tr>
                                          <th>Fecha y hora</th>
                                          <th>Usuario</th>
                                          <th>Acción / servicio</th>
                                          <th>Archivos</th>
                                          <th>Dispositivo</th>
                                          <th>IP</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (registro of auditoriaSubidas; track registro.id) {
                                          <tr>
                                            <td class="text-nowrap">{{ registro.fecha }}</td>
                                            <td>
                                              <strong>{{ registro.usuario_nombre }}</strong><br>
                                              <small>{{ registro.usuario_login }} · {{ registro.usuario_perfil }}</small>
                                            </td>
                                            <td>
                                              <strong>{{ registro.accion }}</strong><br>
                                              <small>{{ registro.servicios }}</small>
                                            </td>
                                            <td>
                                              <strong>{{ resumenArchivosAuditoria(registro) }}</strong>
                                              @if (archivosAuditoria(registro).length > 0) {
                                                <button type="button" class="btn btn-link btn-sm p-0 d-block mt-1"
                                                  (click)="abrirArchivosAuditoria(mdlArchivoAuditoria, registro)">
                                                  <i class="fa fa-eye mr-1"></i>Ver archivos ({{ archivosAuditoria(registro).length }})
                                                </button>
                                              } @else {
                                                <small class="d-block text-muted mt-1">Vista previa no disponible para cargas anteriores.</small>
                                              }
                                            </td>
                                            <td>
                                              <strong>{{ registro.dispositivo }}</strong><br>
                                              <small>{{ registro.plataforma }} · {{ registro.pantalla_resolucion }} · {{ registro.idioma }}</small><br>
                                              <small [title]="registro.user_agent">{{ registro.user_agent }}</small>
                                            </td>
                                            <td class="text-nowrap">{{ registro.ip }}</td>
                                          </tr>
                                        }
                                        @if (auditoriaSubidas.length === 0) {
                                          <tr>
                                            <td colspan="6" class="text-center text-muted py-4">No existen registros para mostrar.</td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>

                                  <div class="d-flex justify-content-between align-items-center mt-3">
                                    <small class="text-muted">{{ auditoriaTotal }} registro(s) · Página {{ auditoriaPagina }} de {{ auditoriaTotalPaginas }}</small>
                                    <div>
                                      <button class="btn btn-sm btn-outline-primary mr-2" type="button"
                                        [disabled]="auditoriaPagina <= 1"
                                        (click)="cambiarPaginaAuditoria(auditoriaPagina - 1)">Anterior</button>
                                      <button class="btn btn-sm btn-outline-primary" type="button"
                                        [disabled]="auditoriaPagina >= auditoriaTotalPaginas"
                                        (click)="cambiarPaginaAuditoria(auditoriaPagina + 1)">Siguiente</button>
                                    </div>
                                  </div>
                                }
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" (click)="modal.close()">Cerrar</button>
                              </div>
                            </ng-template>

                            <ng-template #mdlArchivoAuditoria let-modal>
                              <div class="modal-header bg-dark">
                                <div>
                                  <h6 class="modal-title mb-0 text-white">
                                    <i class="fa fa-eye mr-2"></i>Archivos cargados
                                  </h6>
                                  <small class="text-white-50">{{ archivosAuditoriaSeleccionados.length }} archivo(s)</small>
                                </div>
                                <button type="button" class="close text-white" aria-label="Close" (click)="modal.dismiss()">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body text-center">
                                @for (archivo of archivosAuditoriaSeleccionados; track archivo.url) {
                                  <div class="card mb-3">
                                    <div class="card-header text-left">
                                      <strong>{{ archivo.categoria }}</strong> · {{ archivo.servicio }}
                                    </div>
                                    <div class="card-body">
                                      @if (esImagenAuditoria(archivo)) {
                                        <img [src]="archivo.url" class="img-fluid rounded" [alt]="archivo.servicio">
                                      } @else if (esVideoAuditoria(archivo)) {
                                        <video [src]="archivo.url" controls class="w-100"></video>
                                      } @else {
                                        <i class="fa fa-file-o text-primary mb-3" style="font-size: 4rem;"></i>
                                        <p>Vista previa no disponible para este tipo de archivo.</p>
                                      }
                                      <a [href]="archivo.url" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-primary mt-2">
                                        <i class="fa fa-external-link mr-1"></i>Abrir archivo
                                      </a>
                                    </div>
                                  </div>
                                }
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" (click)="modal.close()">Cerrar</button>
                              </div>
                            </ng-template>

                            <!-- ----------------------------------------------------------------------- -->
                            <!--                      MODAL CÓDIGOS DISPONIBLES PAQUETE                  -->
                            <!-- ----------------------------------------------------------------------- -->
                            <ng-template #mdlCodigosPaquete let-modal>
                              <div class="modal-header bg-primary">
                                <div>
                                  <h6 class="modal-title mb-0 text-white">
                                    <i class="fa fa-cube mr-2"></i> Códigos Disponibles del Paquete
                                  </h6>
                                  @if (paqueteSeleccionadoCod) {
                                    <small class="text-white-50">
                                      {{ paqueteSeleccionadoCod.NOM_CLI }} &bull; Factura: {{ paqueteSeleccionadoCod.NUM_TRAC }}
                                    </small>
                                  }
                                </div>
                                <button type="button" class="close text-white" aria-label="Close" (click)="modal.dismiss()">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">

                                <!-- Buscador -->
                                <div class="mb-3" style="position: relative;">
                                  <i class="fe fe-search text-muted" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); z-index: 1; pointer-events: none;"></i>
                                  <input type="text" class="form-control" placeholder="Buscar código..."
                                    style="padding-left: 36px; padding-right: 36px;"
                                    [(ngModel)]="busquedaCodigoPaquete" (input)="filtrarCodigosPaquete()"
                                    autofocus>
                                  @if (busquedaCodigoPaquete) {
                                    <button type="button"
                                      style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: none; border: none; padding: 0; color: #999; cursor: pointer; z-index: 1;"
                                      (click)="busquedaCodigoPaquete=''; filtrarCodigosPaquete()">
                                      <i class="fe fe-x"></i>
                                    </button>
                                  }
                                </div>

                                <!-- Info de resultados -->
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                  <span class="badge badge-info">
                                    <i class="fe fe-list mr-1"></i>{{ codigosPaqueteFiltrados.length }} código(s)
                                  </span>
                                  @if (totalPaginasCodigos > 1) {
                                    <small class="text-muted">
                                      Página {{ paginaCodigoPaquete }} de {{ totalPaginasCodigos }}
                                    </small>
                                  }
                                </div>

                                <!-- Tabla -->
                                <div class="table-responsive">
                                  <table class="table table-hover table-bordered mb-0" style="font-size: 0.9rem;">
                                    <thead style="background-color: #f0f4ff;">
                                      <tr>
                                        <th style="width: 50px;" class="text-center">#</th>
                                        <th>CÓDIGO DISPONIBLE</th>
                                        <th style="width: 140px;" class="text-center">ACCIÓN</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (item of codigosPaquetePaginados(); track item; let i = $index) {
                                        <tr
                                          style="cursor: pointer;" (click)="seleccionarCodigoPaquete(item.codigo)">
                                          <td class="text-center text-muted">
                                            {{ (paginaCodigoPaquete - 1) * itemsPorPaginaPaquete + i + 1 }}
                                          </td>
                                          <td>
                                            <i class="zmdi zmdi-collection-text text-success mr-2"></i>
                                            <strong>{{ item.etiqueta | removeLeadingZeros }}</strong>
                                          </td>
                                          <td class="text-center">
                                            <button class="btn btn-sm btn-success" type="button"
                                              (click)="$event.stopPropagation(); seleccionarCodigoPaquete(item.codigo)">
                                              <i class="fe fe-check-circle mr-1"></i>Usar
                                            </button>
                                          </td>
                                        </tr>
                                      }
                                      @if (codigosPaqueteFiltrados.length === 0) {
                                        <tr>
                                          <td colspan="3" class="text-center text-muted py-4">
                                            <i class="fe fe-search" style="font-size: 2rem; display: block; margin-bottom: 8px;"></i>
                                            No se encontraron códigos con "<strong>{{ busquedaCodigoPaquete }}</strong>"
                                          </td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>

                                <!-- Paginación -->
                                @if (totalPaginasCodigos > 1) {
                                  <div class="d-flex justify-content-center mt-3">
                                    <nav aria-label="Paginación de códigos">
                                      <ul class="pagination pagination-sm mb-0">
                                        <li class="page-item" [class.disabled]="paginaCodigoPaquete === 1">
                                          <a class="page-link" href="javascript:;" (click)="paginaCodigoPaquete = paginaCodigoPaquete - 1" aria-label="Anterior">
                                            <i class="fe fe-chevron-left"></i>
                                          </a>
                                        </li>
                                        @for (p of getPaginasCodigos(); track p) {
                                          <li class="page-item" [class.active]="paginaCodigoPaquete === p">
                                            <a class="page-link" href="javascript:;" (click)="paginaCodigoPaquete = p">{{ p }}</a>
                                          </li>
                                        }
                                        <li class="page-item" [class.disabled]="paginaCodigoPaquete === totalPaginasCodigos">
                                          <a class="page-link" href="javascript:;" (click)="paginaCodigoPaquete = paginaCodigoPaquete + 1" aria-label="Siguiente">
                                            <i class="fe fe-chevron-right"></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav>
                                  </div>
                                }

                              </div>
                              <div class="modal-footer d-flex justify-content-between align-items-center">
                                <small class="text-muted">
                                  <i class="fe fe-info mr-1"></i>Haz clic en cualquier fila o en "Usar" para seleccionar el código
                                </small>
                                <button type="button" class="btn btn-secondary btn-sm" (click)="modal.close()">
                                  <i class="fe fe-x mr-1"></i>Cerrar
                                </button>
                              </div>
                            </ng-template>
